// Recipe data for Grounded Wellness with Jill
// Categories: teas, smoothies, soups, mains, essentials, dressings

export const recipes = [
  // ============ TEAS (from Tea Guide) ============
  {
    id: 'lemon-ginger-tea',
    title: 'Lemon Ginger Tea',
    category: 'teas',
    tags: ['Detox Friendly', 'Yellow / Fire', 'Orange / Flow'],
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/405bewkx_118319374_3193403567418360_5665096878203203605_n.webp',
    description: 'A simple and invigorating tea. Ginger stimulates digestion, reduces bloating, and enhances circulation, while lemon boosts vitamin C & liver detox.',
    ingredients: [
      '1 inch fresh ginger root, grated',
      '2 cups water',
      'Juice of 1/2 lemon',
      '1 teaspoon honey (optional)'
    ],
    instructions: [
      'Simmer grated ginger in water for 10 minutes.',
      'Strain into a cup and add lemon juice and honey.',
      'Stir and serve warm or make ahead and serve cold.'
    ],
    tips: 'High powered blenders work best for grating ginger.'
  },
  {
    id: 'hibiscus-refresher',
    title: 'Hibiscus Refresher',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root'],
    image: 'https://images.pexels.com/photos/5947020/pexels-photo-5947020.jpeg?w=600',
    description: 'A ruby-red hibiscus tea with a hint of honey and a fragrant sprig of rosemary. Tart, floral, and beautiful — lovely served chilled over ice or sipped warm.',
    servings: '1–2 servings',
    time: '5–10 minutes',
    ingredients: [
      'Hibiscus tea (loose or bagged)',
      'Honey, to taste',
      'A sprig of rosemary',
    ],
    instructions: [
      'Brew the hibiscus tea and stir in honey to taste.',
      'Bruise the rosemary first — give it a few light chops with the back of your knife so it releases its magic.',
      'Drop the bruised rosemary sprig in to infuse, then serve warm or chilled over ice.',
    ],
    tips: 'Bruising the rosemary is the secret — it wakes up the oils and perfumes the whole glass. Hibiscus is rich in antioxidants and naturally tart, so adjust the honey to your taste.'
  },
  {
    id: 'metabolism-herbal-tea',
    title: 'Metabolism & Weight-Support Herbal Tea',
    category: 'teas',
    tags: ['Detox Friendly', 'Yellow / Fire'],
    image: 'https://static.prod-images.emergentagent.com/jobs/ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/images/486a62bcb68bb442173efb522052d6aa116f37038fd4a894389ccedca0e311fa.png',
    description: 'Supporting a healthy weight is about so much more than burning fat — it is about metabolism, cravings, digestion, blood sugar balance, water balance, and helping the body feel less sluggish, swollen, and stuck. This warming blend leans on five time-honoured herbs — Ceylon cinnamon, dandelion root, fenugreek, hibiscus, and stinging nettle — traditionally used to support metabolic wellness, digestion, fluid balance, and the body\'s own natural detox pathways.',
    servings: '1–2 servings',
    time: '10–15 minutes',
    ingredients: [
      'Ceylon cinnamon (a small stick or 1/2 tsp)',
      'Dandelion root (1 tsp)',
      'Fenugreek seeds (1/2 tsp)',
      'Dried hibiscus (1 tsp)',
      'Stinging nettle leaf (1 tsp)',
      '2–3 cups just-boiled water',
      'Honey or lemon, optional to taste',
    ],
    instructions: [
      'Add all the herbs to a pot or large infuser.',
      'Pour over just-boiled water and cover.',
      'Steep 10–15 minutes — the longer you steep, the deeper the flavour and the more of the root and seed you draw out.',
      'Strain, then sweeten lightly with honey or brighten with a squeeze of lemon if you like. Enjoy warm, or chill over ice.',
    ],
    tips: 'A little spotlight on each herb — feel free to make a single-herb tea or blend them all:\n\n• Ceylon cinnamon — loved for metabolic support, steady blood sugar, and easing sugar cravings and energy crashes.\n• Dandelion root — a classic for digestion, liver support, bloating and puffiness, helping the body process what it may be holding onto.\n• Fenugreek — traditionally used for appetite support, digestion, blood sugar balance, and helping you feel fuller and more satisfied.\n• Hibiscus — bright, tart and antioxidant-rich; supports water balance, circulation, a calm inflammatory response, and that lighter, refreshed feeling.\n• Stinging nettle — mineral-rich and traditionally used for fluid balance, kidney support, deep nourishment, and helping the body release what it does not need.'
  },
  {
    id: 'ginger-turmeric-zest-tea',
    title: 'Ginger Turmeric Zest Tea',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1571934811356-5cc061b6821f?w=600',
    description: 'A warming blend that supports digestion and reduces inflammation while aiding liver detox.',
    ingredients: [
      '1-inch fresh ginger, sliced',
      '1/2 teaspoon ground turmeric (or 1 teaspoon fresh, grated)',
      '1 cup water',
      '1 teaspoon honey',
      'Juice of 1/2 lemon',
      'Dash of black pepper (to activate turmeric\'s properties)'
    ],
    instructions: [
      'Simmer ginger and turmeric in water for 10 minutes.',
      'Strain into a cup and stir in honey and lemon juice.'
    ],
    tips: 'The black pepper is essential - it activates the curcumin in turmeric by 2000%!'
  },
  {
    id: 'dandelion-cinnamon-tea',
    title: 'Dandelion Cinnamon Tea',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow'],
    image: 'https://images.unsplash.com/photo-1597318181409-cf64d0b5d8a2?w=600',
    description: 'This aromatic tea supports liver function and digestion while adding a cozy twist with cinnamon.',
    ingredients: [
      '1 teaspoon dried dandelion root',
      '1 stick cinnamon',
      '2 cups water',
      '1 teaspoon honey (optional)'
    ],
    instructions: [
      'Boil water and add dandelion root and cinnamon.',
      'Simmer for 15 minutes.',
      'Strain and add honey if desired.'
    ],
    tips: 'Dandelion root is one of the best liver cleansers available.'
  },
  {
    id: 'rosehip-orange-zest-tea',
    title: 'Rose Hip & Orange Zest Tea',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow'],
    image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=600',
    description: 'Rose hips are rich in vitamin C for immune support, while orange zest adds a bright, citrusy flavor.',
    ingredients: [
      '1 teaspoon dried rose hips',
      'Zest of 1/2 orange',
      '1 cinnamon stick',
      '2 cups hot water'
    ],
    instructions: [
      'Steep rose hips and orange zest in hot water for 10 minutes.',
      'Add the cinnamon stick, strain, and serve warm.'
    ],
    tips: 'Rose hips contain more vitamin C than oranges!'
  },
  {
    id: 'peppermint-green-tea',
    title: 'Peppermint Green Tea Refresher',
    category: 'teas',
    tags: ['Detox Friendly', 'Green / Love', 'Blue / Truth'],
    image: 'https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=600',
    description: 'A refreshing combo that soothes digestion, boosts energy, and promotes detox and anti-aging.',
    ingredients: [
      '1 green tea bag',
      '1 tbsp fresh peppermint leaves (or 1 teaspoon dried)',
      '1 cup hot water',
      '1 teaspoon honey'
    ],
    instructions: [
      'Steep green tea and peppermint leaves in hot water for 5 minutes.',
      'Strain, add honey, and enjoy.'
    ],
    tips: 'Great for afternoon energy without the crash.'
  },
  {
    id: 'nighttime-calm-tea',
    title: 'Night Time Calm Digestive Tea',
    category: 'teas',
    tags: ['Detox Friendly', 'Green / Love', 'Orange / Flow', 'Blue / Truth'],
    image: 'https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9?w=600',
    description: 'A calming digestive tea perfect for winding down before bed.',
    ingredients: [
      '1 tsp Chamomile leaves (or bag)',
      'Peppermint dried or fresh leaves',
      '1 tsp grated ginger',
      '1 cup hot water'
    ],
    instructions: [
      'Steep chamomile, peppermint and ginger in hot water for 5-7 minutes.',
      'Strain and enjoy before bed.'
    ],
    tips: 'Chamomile is naturally calming and supports digestive health.'
  },
  {
    id: 'fennel-citrus-detox-tea',
    title: 'Fennel Citrus Detox Delight',
    category: 'teas',
    tags: ['Detox Friendly', 'Orange / Flow', 'Yellow / Fire', 'Green / Love'],
    image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=600',
    description: 'Supports gut health and adds a citrusy zing for extra detoxifying & immune power.',
    ingredients: [
      '1 teaspoon fennel seeds, lightly crushed',
      'Zest of 1 orange',
      '1.5 cups water',
      'Juice of 1/2 lemon'
    ],
    instructions: [
      'Simmer fennel seeds and orange zest in water for 7 minutes.',
      'Strain and stir in lemon juice.'
    ],
    tips: 'Fennel is excellent for bloating relief and gut soothing.'
  },
  {
    id: 'clove-ginger-detox-tea',
    title: 'Clove Ginger Detox Tea',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow'],
    image: 'https://images.unsplash.com/photo-1558160074-4d7d8bdf4256?w=600',
    description: 'Kills bacteria in the mouth, expels mucus from lungs, supports immune system.',
    ingredients: [
      '1 inch of ginger',
      '1 Cinnamon Stick',
      '1/4 tsp cloves',
      '3 cups of boiling water',
      'Honey and lemon juice (optional)'
    ],
    instructions: [
      'Simmer all ingredients over medium heat for 5 minutes.',
      'Strain and cool to taste.',
      'Add in honey and/or lemon juice if desired.'
    ],
    tips: 'Always use Ceylon cinnamon for best results and health benefits.'
  },
  {
    id: 'burdock-licorice-tea',
    title: 'Burdock Root & Licorice Spice',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow'],
    image: 'https://images.unsplash.com/photo-1597481499750-3e6b22637e12?w=600',
    description: 'Burdock root detoxifies the blood, and licorice adds sweetness and supports the adrenal glands.',
    ingredients: [
      '1 teaspoon dried burdock root',
      '1/2 teaspoon dried licorice root',
      '1 cinnamon stick',
      '2 cups water',
      'Honey (optional)'
    ],
    instructions: [
      'Simmer all ingredients in water for 10 minutes.',
      'Strain and enjoy warm.',
      'Add honey if desired.'
    ],
    tips: 'Burdock is a powerful blood purifier and supports skin health.'
  },

  // ============ ELIXIRS ============
  {
    id: 'liver-flush',
    title: 'The Liver Flush',
    category: 'teas',
    tags: ['Detox Friendly', 'Orange / Flow', 'Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/bh54khuo_detox%20drink.jpg',
    description: 'A powerful detox drink designed to enhance the liver\'s detoxing functions. Moves toxins out of liver, gall bladder and kidneys - 3 very important organs for digestion, metabolism and healthy bodies.',
    ingredients: [
      '300ml grapefruit juice and lemon (just over a cup - use 1 grapefruit, 1/2 lemon)',
      '200ml (3/4 cup) filtered water to dilute',
      '2 cloves garlic',
      '1 inch fresh ginger root',
      '2 tbsp extra virgin olive oil'
    ],
    instructions: [
      'Either press the garlic and ginger with a garlic press, or blend everything in blender or Nutribullet.',
      'Then strain to pull pulp out.',
      'Drink slowly and restfully, enjoying some time with yourself.',
      'Follow with 2-3 cups of herbal tea - any combination of fennel, dandelion, fenugreek, peppermint, chickweed, nettle, parsley or any detox tea you like.'
    ],
    tips: 'The Liver flush is designed to be done roughly once a week to enhance the liver\'s detoxing functions. If you have currently or ever had any gallbladder issues, use only 1 tbsp or less of olive oil to avoid triggering an attack. Everyone responds differently - usually done around day 7, 14, 21 ish of a cleanse.'
  },
  {
    id: 'my-chai-latte',
    title: 'My Chai Latte',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root'],
    image: 'https://images.unsplash.com/photo-1578899952107-9c390f1af1b7?w=600',
    description: 'A coffee substitute with umph and robustness! Can be served sweet, warm or cold. Perfect as dessert, a cozy evening treat, or mid afternoon when we often crave sugar.',
    ingredients: [
      '1/2 cup coconut water',
      '1/2 cup almond milk (or other dairy substitute, unsweetened)',
      '2 tbsp coconut milk (organic canned)',
      '2-3 green or herbal chai tea bags (rooibos chai is nice)',
      'Lots of cinnamon (sticks are great, powder is ok)',
      'Star anise (optional, but nice)',
      'Honey to taste'
    ],
    instructions: [
      'In a pot on the stove, on low heat, add the coconut water, almond milk to a pot.',
      'Add tea bags and spices.',
      'Steep for 10-20 minutes - do not boil.',
      'Squeeze teabags for max flavor.',
      'Add extra cinnamon to trick the palate into sweetness and to regulate blood sugar.',
      'Once removed from heat, add the canned coconut milk for richness (do not cook this milk).',
      'Add some honey to taste for extra sweetness once off heat - honey is not meant to be cooked.'
    ],
    tips: 'I often double or triple the recipe to have for a few days. This makes a great coffee substitute - regular tea doesn\'t really cut it for those who need a little umph!'
  },
  {
    id: 'pineapple-ginger-juice',
    title: 'Pineapple Ginger Juice',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow', 'Yellow / Fire', 'Blue / Truth'],
    image: 'https://images.unsplash.com/photo-1705246535138-953e01125cb0?w=600',
    description: 'A delicious, versatile juice that tastes great and aids in digestion. Perfect on its own or mixed with other elixirs.',
    ingredients: [
      'One pineapple (skins reserved for Tepache if desired)',
      '1-3 inches of ginger',
      'Approx 1 cup of water'
    ],
    instructions: [
      'Trim skins of one pineapple.',
      'Place into blender with 1-3 inches of ginger.',
      'Add approx 1 cup of water for ease of blending.',
      'Strain through sieve or cheese cloth.',
      'Keep in the fridge for roughly 6-7 days.',
      'Place unused portion in ice cube trays for easy access later.',
      'Enjoy on its own or mix with other elixirs for combos and interest.'
    ],
    tips: 'Reserve skins for Tepache if desired! This juice is very versatile and great for mixing.'
  },
  {
    id: 'celery-juice',
    title: 'Celery Juice',
    category: 'teas',
    tags: ['Detox Friendly', 'Green / Love'],
    image: 'https://images.unsplash.com/photo-1610622930110-3c076902312a?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'A simple weekend "clear out" that primes the pump and supports your organs. Best made fresh and consumed within an hour or two. It doesn\'t have to be plain — mix in a little carrot and apple, or anything you like, but keep the bulk of it celery.',
    servings: '1 serving (about 1 cup)',
    time: '5 minutes',
    ingredients: [
      'About 8 stalks of celery (roughly 1 head)',
      'Optional: a little carrot and/or apple, to taste',
      'Splash of water (only if using a blender)'
    ],
    instructions: [
      'Wash the celery well.',
      'Run it through a juicer, or blend in a high-powered blender with a splash of water and strain through a sieve or nut-milk bag.',
      'If you like, add a little carrot or apple for sweetness — but keep the bulk of it celery.',
      'Drink immediately (roughly 1 cup). It is best consumed within one to two hours of making.'
    ],
    tips: 'On the weekends, when you have a little more time, having it both days helps your body do a little "clear out." Great first thing in the morning on an empty stomach.'
  },

  {
    id: 'tepache',
    title: 'Tepache',
    category: 'teas',
    tags: ['CRAP Cleanse Friendly', 'Orange / Flow', 'Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/kaj46eii_how-long-to-ferment-tepache.jpg',
    description: 'A lovely probiotic drink with gut boosting, health reversing potential. Similar to Kombucha with a pineapple beer-ish flavour.',
    ingredients: [
      'Skins & core of one pineapple',
      '1/2 cup of desired sugar (avoid honey due to antiseptic properties)',
      'Filtered water'
    ],
    instructions: [
      'Wash pineapple in warm water and lemon juice, vinegar, or dish soap. Discard top and bottom.',
      'Place skins & core in a large mason jar (1/2 gallon).',
      'Dissolve 1/2 cup of sugar into some warm water, add to jar.',
      'Fill jar 1-2 inches from top - ensure all pineapple is covered in water (exposed pineapple may spoil).',
      'Cover with paper towel, fermenting lid or loosely fitting lid. Burp daily, can stir daily with non-metal utensil or swirl gently.',
      'Place in non-direct light, warm-ish place in home for 3 days.',
      'Strain and refrigerate.',
      'Drink at your liking - best before a meal, but enjoy anytime.'
    ],
    tips: 'Beneficial especially in the AM before food consumption to get healthy bacteria into the digestive tract first. Should be stable for a long time. YouTube has about 1000 videos for more info!'
  },
  {
    id: 'lemon-elixir',
    title: 'Lemon Elixir',
    category: 'teas',
    tags: ['Detox Friendly', 'Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/hbsl15r2_straining_lemon_olive_oil_elixir.png',
    description: 'Yummy, tangy, sharp, surprisingly delish! Really gets the liver and kidney going and has a clarifying effect.',
    ingredients: [
      '1 whole organic lemon (seeds removed, rind included)',
      '1 tsp Ceylon cinnamon',
      '2 tbsp high quality olive oil',
      '2 tbsp honey (local is always best)',
      '1-2 inches of ginger',
      '2-3 cups of filtered water (use less for stronger flavor)'
    ],
    instructions: [
      'Blend everything in high powered blender.',
      'Strain.',
      'Store in fridge up to a week.',
      'Ice cube freeze what you won\'t get to.',
      'Drink 1/2 cup in the AM as a liver activator, or enjoy throughout the day.'
    ],
    tips: 'This elixir really gets the liver and kidney going. Great as a morning liver activator!'
  },
  {
    id: 'golden-smoothie',
    title: 'Golden Smoothie',
    category: 'teas',
    tags: ['CRAP Cleanse Friendly', 'Orange / Flow', 'Yellow / Fire'],
    image: 'https://images.pexels.com/photos/15082978/pexels-photo-15082978.jpeg?w=600',
    description: 'An effortless, delish, nutritious anti-inflammatory smoothie. My time-crunched HANGRY solution!',
    ingredients: [
      '1/2 cup of Pineapple Ginger Juice',
      '1/2 cup Lemon Elixir',
      '1/4-1/2 cup coconut milk',
      '1 tsp turmeric',
      '1/8 tsp black pepper',
      'Pinch of salt',
      'Extra honey (optional, for sweeter treat)'
    ],
    instructions: [
      'Combine all ingredients.',
      'Add ice and enjoy.'
    ],
    tips: 'Healthy, delish, anti-inflammatory & really takes the edge off of an appetite in a pinch. This is my time-crunched HANGRY Solution!'
  },
  {
    id: 'upgraded-cucumber-lemon-water',
    title: 'Upgraded Cucumber Lemon Water',
    category: 'teas',
    tags: ['Yellow / Fire', 'Green / Love', 'Blue / Truth'],
    image: 'https://images.pexels.com/photos/2109099/pexels-photo-2109099.jpeg?w=600',
    description: 'A crisp, hydrating cooler that turns plain water into something special. Cucumber soothes and hydrates, lemon brightens and gently detoxifies, and a touch of honey rounds it all out — refreshing without the refined sugar.',
    ingredients: [
      '1/2 cup water',
      'Honey, to taste',
      '3 cucumbers',
      '3 lemons'
    ],
    instructions: [
      'Peel (optional) and roughly chop the cucumbers. Juice the lemons.',
      'Blend the cucumbers with the water until smooth, then strain through a fine sieve or nut-milk bag for a clean, refreshing base.',
      'Stir in the fresh lemon juice.',
      'Add honey to taste, stirring until dissolved (warm a spoonful slightly if it needs help blending in).',
      'Pour over ice, garnish with cucumber ribbons or a lemon slice, and enjoy.'
    ],
    tips: 'Honey to taste — start small and adjust. Swapped in for refined sugar, it adds a gentle sweetness plus its own soothing benefits. Keep it light to let the cucumber and lemon shine.'
  },
  {
    id: 'tulum-cacao',
    title: 'Tulum Cacao',
    category: 'teas',
    tags: ['Detox Friendly', 'Red / Root'],
    image: 'https://images.pexels.com/photos/6802983/pexels-photo-6802983.jpeg?w=600',
    description: 'Best cacao ever! Hello sweet loves — a warming, spiced ceremonial-style cacao with coconut milk, cinnamon, turmeric, ginger, cardamom, and star anise. Rich, grounding, and deeply comforting. Serves 4.',
    ingredients: [
      '1/2 cup pure cacao',
      '4 cups purified water',
      '2 cups coconut milk',
      '1/4 cup piloncillo (unrefined cane sugar)',
      '1 cinnamon stick',
      '1 inch turmeric root (or 1 tsp grated)',
      '1 inch ginger root (or 1 tsp grated)',
      '1/2 tsp cardamom (or about 4 pods)',
      '1 piece star anise'
    ],
    instructions: [
      'Combine all ingredients in a pot.',
      'Simmer gently on low heat, stirring, until rich and fragrant.',
      'Strain if desired and serve warm.'
    ],
    tips: 'Will last a few days in the fridge — reheat for easy, comforting convenience.'
  },
  {
    id: 'homemade-electrolyte-drink',
    title: 'Homemade Electrolyte Drink',
    category: 'teas',
    tags: ['Detox Friendly', 'Orange / Flow', 'Blue / Truth'],
    image: 'https://images.unsplash.com/photo-1623084918757-56d74eb2c650?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'A naturally hydrating electrolyte drink made with coconut water, real juice, citrus, and a pinch of sea salt. Endlessly customizable — pick a variation below based on what you have on hand.',
    servings: '2 servings',
    time: '5 minutes',
    ingredients: [
      '1.5 cups unsweetened coconut water',
      '1 cup 100% juice of choice (see variations below)',
      '2 tablespoons fresh lime or lemon juice, or to taste',
      '2 tablespoons honey',
      '1/8 teaspoon sea salt',
      '1/2 cup water',
      'Ice, for serving',
      '— Variation · Citrus —',
      '1 cup 100% orange juice',
      '1 tablespoon lemon juice',
      '1 tablespoon lime juice',
      '— Variation · Watermelon Lemon —',
      '1 cup 100% watermelon juice',
      '2 tablespoons lemon juice',
      '— Variation · Cherry & Lime —',
      '1 cup 100% tart cherry juice',
      '2 tablespoons lime juice',
      '— Variation · Grapefruit & Lime —',
      '1 cup 100% grapefruit juice',
      '2 tablespoons lime juice'
    ],
    instructions: [
      'In a jug or large glass, combine the coconut water, your chosen 100% juice, the lime or lemon juice, honey, sea salt, and water.',
      'Stir well until the honey and salt fully dissolve.',
      'Taste and adjust the citrus or honey to your liking.',
      'Pour over ice and serve. Store any leftovers in the fridge for up to 2 days.'
    ],
    tips: 'Choose one of the variations for your 1 cup of juice: Citrus, Watermelon Lemon, Cherry & Lime, or Grapefruit & Lime. The pinch of sea salt is what makes it a true electrolyte drink — don\u2019t skip it. Lovely after movement, a sauna, or a hot Bermuda day.'
  },
  {
    id: 'iced-citrus-electrolyte-drink',
    title: 'Iced Citrus Electrolyte Drink',
    category: 'teas',
    tags: ['Detox Friendly', 'Orange / Flow', 'Blue / Truth'],
    image: 'https://images.unsplash.com/photo-1651993737174-6890c1daef5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'A simple, hydrating citrus electrolyte drink — especially good iced in the summers. SO GOOD! Mix and match your citrus, and add cream of tartar for a potassium boost.',
    servings: '3 servings',
    time: '5 minutes',
    ingredients: [
      '3 cups water',
      '1 orange, juiced (or use 2 oranges, 2 lemons, or limes — mix and match to taste)',
      '1 lemon, juiced',
      '1/8 teaspoon baking soda',
      '1/8 teaspoon cream of tartar (for potassium)',
      '1/2 teaspoon salt',
      '2 tablespoons honey',
      'Ice, for serving'
    ],
    instructions: [
      'Combine all ingredients in a jar or bottle.',
      'Shake well until the honey, salt, baking soda, and cream of tartar fully dissolve.',
      'Taste and sprinkle in a little more salt if you like — it cuts through the bitterness of the citrus.',
      'Serve over plenty of ice.'
    ],
    tips: 'I even do limes a lot! The cream of tartar adds potassium, and the pinch of baking soda + salt make it a true electrolyte drink. Best enjoyed cold on a hot day.'
  },
  {
    id: 'purple-summer-bliss',
    title: 'Purple Summer Bliss',
    category: 'teas',
    tags: ['Detox Friendly', 'Violet / Spirit', 'Red / Root'],
    image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'A gorgeous deep-purple juice — hydrating, antioxidant-rich, and a lovely fit for the crown chakra. Sweet, crisp, and gently spiced with ginger.',
    servings: '2 servings',
    time: '10 minutes',
    ingredients: [
      '~2 cups chopped purple cabbage (about 200 g / ¼ small head)',
      '~⅔ cup pineapple chunks (about 100 g)',
      '~1 small cucumber, or ¾ cup chopped (about 100 g)',
      '1 large pear (about 200 g)',
      '1 large apple (about 200 g)',
      '~2-inch piece of ginger, about 3 tbsp (about 40 g)'
    ],
    instructions: [
      'Assemble all ingredients.',
      'Wash and cut all ingredients into chunks suitable for the juicer.',
      'Juice everything (purple cabbage, pineapple, cucumber, pears, apple, ginger).',
      'Whisk and pass through a fine strainer — optional.',
      'Pour into bottles or serving glasses. Best enjoyed fresh, within 1–2 hours.'
    ],
    tips: 'Adjust the ginger up or down to taste. Keep the bulk purple cabbage for that deep crown-chakra color and antioxidant boost.'
  },




  // ============ SMOOTHIES ============
  {
    id: 'coconut-orange-mango-smoothie',
    title: 'Coconut Orange Mango Smoothie',
    category: 'smoothies',
    tags: ['Orange / Flow', 'Yellow / Fire'],
    image: 'https://images.pexels.com/photos/14930492/pexels-photo-14930492.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'A sunny, tropical smoothie of orange, mango, banana, and creamy coconut — pure orange goodness to nourish The Flow (sacral). Hydrating, omega-rich, and naturally sweet.',
    servings: '2 servings',
    ingredients: [
      '1 large orange, peeled and sliced',
      '1 sliced frozen banana',
      '10 ounces frozen mango',
      '1 cup unsweetened coconut milk (full-fat for an ultra-creamy treat, or light to save calories)',
      '1 tablespoon coconut oil'
    ],
    instructions: [
      'Blend the first four ingredients in a high-speed blender until smooth.',
      'With the blender running, slowly pour in melted (but not hot) coconut oil until combined.',
      'Pour into glasses and enjoy right away.'
    ],
    tips: 'All things orange feed the sacral chakra. The coconut oil adds healthy fats that help your body absorb the fat-soluble nutrients in the mango and orange. Make sure the coconut oil is melted but cooled slightly so it blends smoothly instead of seizing.'
  },
  {
    id: 'red-root-smoothie',
    title: 'Red Root Smoothie',
    category: 'smoothies',
    tag: 'Red / Root',
    image: 'https://customer-assets.emergentagent.com/job_1e935ed4-0433-457e-9559-d73f82154bb5/artifacts/gsmitag9_OSK%20%281%29.jpg',
    description: 'A vibrant red smoothie to nourish The Root — the system at the base of the spine associated with stability, safety, and connection to the earth. Beet and carrot give you a solid foundation; ginger and citrus awaken your senses. Drink it to feel anchored, vital, and ready for the day.',
    ingredients: [
      '1 cooked beet',
      '1 carrot',
      '1/2 apple',
      'Small piece of fresh ginger',
      '150 ml fresh orange juice',
      'A handful of celery'
    ],
    instructions: [
      'Add all ingredients to a blender.',
      'Blend on high until smooth and vibrant red.',
      'Pour into a glass and drink immediately for the freshest taste and most active enzymes.'
    ],
    tips: 'For an extra-grounding version, swap the orange juice for warm bone broth (yes, really) — it sounds odd but the earthy + savoury combo is deeply nourishing for The Root. Beets are rich in antioxidants and naturally support liver function and circulation; ginger is warming and anti-inflammatory.'
  },
  {
    id: 'red-root-down',
    title: 'Red, Root Down!',
    category: 'smoothies',
    tag: 'Red / Root',
    image: 'https://customer-assets.emergentagent.com/job_ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/artifacts/vpeat1hv_072a091ef0ad7660842be0aed2f1ab03.jpg',
    description: 'A deeply grounding red blend for The Root — beet, red apple, carrots, and ginger. Sip it slow, feel your feet, and remember: you belong here.',
    ingredients: [
      '1 cooked or raw beet',
      '1 red apple',
      '2 carrots (try a mix of colors — orange, purple, yellow)',
      'Small piece of fresh ginger',
      '--- Optional superfoods (1 tsp each) ---',
      'Maca',
      'Ashwagandha',
      'Reishi',
      'Chaga',
      'Cordyceps',
      'Siberian ginseng',
    ],
    instructions: [
      'Blend in a high-powered blender, or run through a juicer.',
      'Enjoy as a juice if you strain the blender, OR…',
      'Add coconut water, coconut milk, or your favorite nut milk to make it a smoothie.',
      'Add a pinch of vitamin C powder as a natural preservative if you\'re splitting the batch into 2 days.',
    ],
    tips: 'Optional grounding superfoods (add 1 tsp of any): Maca, Ashwagandha, Reishi, Chaga, Cordyceps, or Siberian ginseng. These are all adaptogens and Root-supportive — pick one or layer a few. Beets are blood-tonifying and rich in nitrates that support circulation. Drink it slowly, with both feet on the floor.'
  },
  {
    id: 'orange-rise-up',
    title: 'Orange, Rise Up!',
    category: 'smoothies',
    tag: 'Orange / Flow',
    image: 'https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=600',
    description: 'A bright, juicy orange blend for The Flow — carrots, citrus, mango, and grapefruit. Warm, creative, and a little playful. Perfect for moving energy that\'s been stuck.',
    ingredients: [
      '2 carrots',
      '1 orange (try a blood orange for extra depth)',
      '1/2 grapefruit',
      '1/2 mango (fresh or frozen)',
      'Juice of 1/2 lemon',
      '--- Optional superfoods (1 tsp each) ---',
      'Maca',
      'Ashwagandha',
      'Reishi',
      'Chaga',
      'Cordyceps',
      'Siberian ginseng',
    ],
    instructions: [
      'Blend in a high-powered blender, or run through a juicer.',
      'Enjoy as a juice if you strain the blender, OR…',
      'Add coconut water, coconut milk, or your favorite nut milk to make it a smoothie.',
      'Add a pinch of vitamin C powder as a natural preservative if you\'re splitting the batch into 2 days.',
    ],
    tips: 'Blood oranges are stunning here — both visually and nutritionally (more anthocyanins than regular oranges). For an extra-warming twist, grate a little fresh ginger or turmeric in. Optional superfoods (1 tsp each): Maca, Ashwagandha, Reishi, Chaga, Cordyceps, Siberian ginseng. These are not strictly orange-aligned but support overall vitality and creative energy.'
  },
  {
    id: 'green-love-smoothie',
    title: 'Green Love Smoothie',
    category: 'smoothies',
    tag: 'Green / Love',
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=600',
    description: 'A creamy green smoothie to nourish The Love — the heart-centered system of compassion, expansion, and connection. Avocado and cucumber bring smoothness and cool freshness; lemon and coconut lift it into something light and bright. A gift to your heart — an invitation to open to love in all its forms.',
    ingredients: [
      '1/2 avocado',
      'A handful of fresh spinach',
      '1 cucumber',
      '30 ml fresh lemon juice',
      'Coconut milk or coconut water, to taste',
      'Honey, to taste'
    ],
    instructions: [
      'Add the avocado, spinach, cucumber, and lemon juice to a blender.',
      'Pour in coconut milk or coconut water to your desired consistency.',
      'Add honey to taste and blend until creamy and bright green.',
      'Pour into a glass and sip slowly — let it feel like an act of self-love.'
    ],
    tips: 'Making this smoothie is more than nourishment — it\'s a small ritual of compassion. The creaminess of avocado and the cool freshness of cucumber make it deeply revitalizing. For a deeper heart-opening version, add a few sprigs of fresh mint or a small handful of microgreens.'
  },
  {
    id: 'parsley-apple-detox-drink',
    title: 'Parsley & Green Apple Detox Drink',
    category: 'teas',
    tag: 'Green / Love',
    image: 'https://images.pexels.com/photos/616833/pexels-photo-616833.jpeg?w=600',
    description: 'A simple, vibrant green detox drink to nourish The Love. Parsley supports the liver and kidneys; green apple balances blood sugar and aids digestion; lemon and ginger lift everything into something bright and energizing. Best on an empty stomach.',
    ingredients: [
      '1 cup fresh parsley leaves',
      '1 green apple',
      '1 cup water',
      'Optional: a squeeze of fresh lemon',
      'Optional: 1 thin slice of fresh ginger'
    ],
    instructions: [
      'Wash the parsley and green apple thoroughly.',
      'Chop the apple into small pieces — no need to peel.',
      'Add parsley, apple, and 1 cup of water to a blender. Blend until smooth.',
      'Strain through a fine sieve or cheesecloth into a glass.',
      'Optionally squeeze in a little lemon or drop in a thin slice of ginger for extra brightness.',
      'Drink immediately on an empty stomach for the best results.'
    ],
    tips: 'Why this little drink works so beautifully:\n\n• Supports liver function — parsley helps produce the enzymes that break down toxins.\n• Improves digestion — apple fiber and parsley\'s natural oils help reduce bloating.\n• Boosts immunity — high vitamin C content fights inflammation.\n• Hydrates your cells — both ingredients are mostly water, keeping you energized.\n\nIngredient highlights:\n• Fresh parsley — rich in antioxidants, supports kidney health, reduces water retention.\n• Green apple — high in fiber, balances blood sugar, aids digestion.\n• Lemon — adds vitamin C, enhances flavor, boosts detox.\n• Ginger — reduces inflammation, soothes the stomach.\n\nModeration is key: don\'t drink this more than once per day.'
  },
  {
    id: 'intuition-smoothie',
    title: 'Intuition Smoothie',
    category: 'smoothies',
    tag: 'Indigo / Insight',
    image: 'https://customer-assets-jt897jd0.emergentagent.net/job_81134321-5da7-4def-a43f-55f0ee7c6a93/artifacts/5iyn47fo_Blueberry-Banana-Smoothie-768x1152.png',
    description: 'A deep purple smoothie to nourish The Insight — the system between the brows, the portal to intuition and inner perception. Dark fruits rich in antioxidants stimulate clarity and awareness. A gift to your senses and your inner wisdom.',
    ingredients: [
      '1 cup frozen blueberries',
      '1 ripe banana',
      '1 tablespoon chia seeds',
      'Almond milk, to taste',
      'A pinch of ground cinnamon'
    ],
    instructions: [
      'Add the frozen blueberries, banana, and chia seeds to a blender.',
      'Pour in almond milk to your desired consistency.',
      'Add a pinch of ground cinnamon.',
      'Blend on high until smooth and a deep, vibrant purple.',
      'Pour into a glass and sip slowly — let it invite you into quiet, focused attention.'
    ],
    tips: 'The blueberry-and-banana combination delivers both exquisite flavor and a powerful, sustained energy boost that keeps you alert and centered. For an even more intuition-supportive twist, add a small handful of frozen blackberries or a teaspoon of cacao nibs. Pair with a moment of silence or journaling for the full ritual effect.'
  },
  {
    id: 'kale-banana-smoothie',
    title: 'Kale Banana Smoothie',
    category: 'smoothies',
    tags: ['Detox Friendly', 'Green / Love', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1610622930110-3c076902312a?w=600',
    description: 'A nutrient-packed green smoothie that\'s creamy and delicious.',
    ingredients: [
      '1/2 c coconut water',
      '1/2 c coconut milk',
      '1 banana',
      '1/2 avocado',
      '2 tsp grated ginger',
      '1 c kale, baby kale or spinach',
      '1/8 cup lemon juice'
    ],
    instructions: [
      'Combine all ingredients in a blender.',
      'Blend until smooth.'
    ],
    tips: 'Adding vitamin C capsule powder helps keep the smoothie fresh for later. Keep portion to 10-12 oz as it\'s calorie-dense.'
  },
  {
    id: 'chunky-monkey-smoothie',
    title: 'The Chunky Monkey',
    category: 'smoothies',
    tags: ['Detox Friendly', 'Violet / Spirit', 'Red / Root'],
    image: 'https://images.unsplash.com/photo-1690642109411-89f854ad9aa7?w=600',
    description: 'A chocolate peanut butter treat that\'s actually good for you. Nice as a dessert!',
    ingredients: [
      '1/2 c coconut water',
      '1/2 c coconut milk',
      '1 banana',
      '1 tbsp raw cacao powder',
      '1-2 tbsp natural peanut butter',
      '1/2 cup ice cubes'
    ],
    instructions: [
      'Combine all ingredients in a blender.',
      'Blend until smooth.'
    ],
    tips: 'Use raw cacao for maximum antioxidants.'
  },
  {
    id: 'strawberry-gingersnap',
    title: 'Strawberry Gingersnap Smoothie',
    category: 'smoothies',
    tags: ['CRAP Cleanse Friendly', 'Red / Root', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=600',
    description: 'A refreshing strawberry smoothie with a ginger kick.',
    ingredients: [
      '1 cup frozen strawberries',
      '1 banana',
      '3-4 inch piece of fresh ginger root, grated',
      '1/4 cup raw almonds',
      '1/2 lemon juice',
      '1 cup coconut water',
      '1 cup almond milk'
    ],
    instructions: [
      'Combine all ingredients in a blender.',
      'Blend until smooth.'
    ],
    tips: 'If using a lower power blender, press ginger instead of using whole to avoid stringiness.'
  },
  {
    id: 'berry-blast-smoothie',
    title: 'Berry Blast',
    category: 'smoothies',
    tags: ['CRAP Cleanse Friendly', 'Red / Root', 'Blue / Truth', 'Violet / Spirit'],
    image: 'https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=600',
    description: 'An antioxidant-rich berry smoothie with ginger and flax.',
    ingredients: [
      '1 c frozen unsweetened raspberries',
      '3/4 c chilled unsweetened almond or rice milk',
      '1/4 c frozen pitted unsweetened cherries or raspberries',
      '1 Tbsp honey (optional)',
      '2 tsp finely grated fresh ginger',
      '1 tsp ground flaxseed',
      '2 tsp fresh lemon juice'
    ],
    instructions: [
      'Combine all ingredients in a blender.',
      'Blend until smooth.'
    ],
    tips: 'Frozen berries make this naturally thick and cold.'
  },
  {
    id: 'raw-mango-monster',
    title: 'Raw Mango Monster',
    category: 'smoothies',
    tags: ['CRAP Cleanse Friendly', 'Orange / Flow', 'Green / Love'],
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=600',
    description: 'A tropical green smoothie with hidden veggies.',
    ingredients: [
      '1 tbsp flax',
      '1 ripe mango or frozen',
      '1 banana',
      '1/2 c water or coconut water',
      '1/2 coconut milk (optional)',
      '1 cup kale, spinach or zucchini',
      'Cinnamon to taste'
    ],
    instructions: [
      'Grind the flax first — pulse it in a coffee grinder, or add it to the blender on its own first to break up the shell so your body can actually absorb it.',
      'Combine all ingredients in a blender.',
      'Blend until smooth.'
    ],
    tips: 'The mango masks the greens perfectly!'
  },
  {
    id: 'intuition-smoothy',
    title: 'Intuition Smoothy',
    category: 'smoothies',
    tags: ['Indigo / Insight'],
    image: 'https://customer-assets.emergentagent.com/job_ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/artifacts/5axsxifk_OIP%20%285%29.webp',
    description: 'A deep, antioxidant-rich blend of dark berries with chia and a touch of acai — nourishing for The Insight. Thick, beautiful, and quietly grounding. A lovely one to sip while you journal or sit in stillness.',
    servings: '1 serving',
    time: '5 minutes',
    ingredients: [
      '1/2 cup blackberries (or blueberries)',
      '1/2 cup blueberries (or other dark berries)',
      '1 tsp acai powder (optional, for an extra antioxidant boost)',
      '1 tbsp chia seeds',
      '1 tsp honey (optional)',
      '1 cup almond milk (or coconut water)',
    ],
    instructions: [
      'Blend all ingredients together until smooth and thick.',
      'Serve with a few extra blueberries or blackberries for garnish.',
    ],
    tips: 'Dark berries and acai are loaded with antioxidants that support The Insight. Pair it with a quiet moment — journaling or a few deep breaths — for the full intuition-supportive ritual.'
  },
  {
    id: 'blue-tea-smoothie',
    title: 'Blue Tea Smoothie',
    category: 'smoothies',
    tags: ['CRAP Cleanse Friendly', 'Blue / Truth', 'Indigo / Insight'],
    image: 'https://images.unsplash.com/photo-1600718374662-0483d2b9da44?w=600',
    description: 'An antioxidant-rich blueberry and green tea blend.',
    ingredients: [
      '3 Tbsp of green tea (brewed and cooled)',
      '1 tsp honey',
      '1.5 c frozen blueberries',
      '1/2 medium banana',
      '3/4 c almond or coconut milk'
    ],
    instructions: [
      'Brew green tea and let cool.',
      'Combine all ingredients in a blender.',
      'Blend until smooth.'
    ],
    tips: 'Green tea adds a metabolism boost!'
  },

  // ============ SOUPS ============
  {
    id: 'cold-pea-watercress-soup',
    title: 'Cold Pea & Watercress Soup',
    category: 'soups',
    tags: ['Detox Friendly', 'Green / Love', 'Blue / Truth'],
    image: 'https://customer-assets.emergentagent.com/job_1e935ed4-0433-457e-9559-d73f82154bb5/artifacts/ud4rmz1h_cold-pea-soup-509049820-e1499270600146.jpg',
    description: 'A vibrant, refreshing green soup of sweet peas, peppery watercress, and mint — light, hydrating, and full of greens. Serve hot or chilled. A lovely one for The Love. Prep 10 min · Cook 25 min · Serves 4.',
    servings: '4 servings',
    time: 'Prep 10 min · Cook 25 min',
    ingredients: [
      '20g butter',
      '1 small onion, finely chopped',
      '350g potatoes, peeled and diced',
      '1 litre vegetable stock',
      '400g peas, fresh or frozen',
      '1 bunch (about 200g) large watercress, washed',
      'Handful of mint leaves',
      '2 tablespoons yogurt or cashew cream',
      'Small bunch of chives, chopped'
    ],
    instructions: [
      'Melt 20g butter in a saucepan and add the finely chopped onion. Soften without colouring for about 10 minutes.',
      'Add the peeled and diced potatoes, pour over 500ml of the vegetable stock, and cook for a further 10 minutes, until the potatoes are soft.',
      'Add the peas and cover with the remaining 500ml vegetable stock.',
      'Bring back to the boil and simmer for a further four minutes. Add the watercress and mint leaves in the final minute to wilt.',
      'Transfer to a blender and whizz until smooth. Serve hot or chilled, with a dollop of yogurt or cashew cream and some chopped chives in each bowl.'
    ],
    tips: 'Peppery watercress and fresh mint make this one a true green-system favourite — feeding The Love. Delicious served cold on a warm day or gently warmed when you want comfort.'
  },
  {
    id: 'roasted-root-vegetable-soup',
    title: 'Roasted Root Vegetable Soup',
    category: 'soups',
    tags: ['Detox Friendly', 'Red / Root'],
    image: 'https://images.unsplash.com/photo-1607800910317-b92a6c395a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxiZWV0cm9vdCUyMHNvdXAlMjBjcmVhbXklMjBib3dsfGVufDB8fHx8MTc4MjY3ODEzMnww&ixlib=rb-4.1.0&q=85',
    description: 'For easy quick meals during the week, soup is great. You\'ll already have bone or veg broth prepared presumably — so making soup is easy! A grounding, root-system favourite. Prep 5 min · Cook 15 min · Serves 4.',
    servings: '4 servings',
    time: 'Prep 5 min · Cook 15 min',
    ingredients: [
      'Leftover roasted root vegetables (beets, carrots, parsnips, etc.)',
      'Bone or vegetable broth/stock, to desired consistency',
      'Cashews (optional, for a creamy detox-friendly version)',
      'Boursin cheese, flavour of choice (optional, when not detoxing)'
    ],
    instructions: [
      'Add leftover roasted veg to a pot and add stock to your desired consistency.',
      'Use a hand blender to blend, or blend first then heat up on the stove.',
      'For a creamy detox-friendly version: soak cashews in hot water for 10–20 minutes, then discard the first water. Add to the blender and mix with fresh water to your desired thickness, then stir into the soup.',
      'Alternatively, add soaked nuts directly to the soup and blend — blending makes them lovely and creamy and adds terrific interest to the soup.',
      'When not detoxing, stir in Boursin cheese of your desired palette — cracked pepper is a favourite. In the winter months this makes a quick, absolutely delish meal.'
    ],
    tips: 'A grounding root-vegetable soup that feeds The Root. The cashew-cream trick keeps it detox friendly; the Boursin version is pure winter comfort.'
  },
  {
    id: 'immune-boosting-soup',
    title: 'Immune Boosting Soup',
    category: 'soups',
    tag: 'Orange / Flow',
    image: 'https://images.pexels.com/photos/539451/pexels-photo-539451.jpeg?w=600',
    description: 'Perfect for fall and winter — a nourishing broth made with chicken, immune-boosting veggies, turmeric, ginger, and garlic. Prep 5 min · Cook 30 min · Serves 8.',
    ingredients: [
      '2 tablespoons tallow/coconut oil or butter',
      '1 leek, white and light green parts only',
      '3 carrots',
      '3 celery stalks',
      '1 orange bell pepper',
      '1 cup cremini mushrooms',
      '3 cloves garlic, minced',
      '3 teaspoons grated fresh ginger',
      '1 inch fresh turmeric, grated (or 1 teaspoon ground turmeric)',
      '2 bay leaves',
      '8 cups chicken stock',
      '1 pound chicken breasts',
      '2 cups baby spinach',
      'Salt and pepper, to taste',
      'Lemon, for serving'
    ],
    instructions: [
      'Heat the fat in a large soup pot.',
      'Slice the leeks and carrots into half moons, dice the celery and bell pepper, and slice the mushrooms.',
      'Add the leeks, carrots, and celery to the pot and sauté until softened and the leek is translucent.',
      'Stir in the bell pepper and mushrooms and cook until tender, about 5 minutes. Stir in the garlic, ginger, turmeric, and bay leaves and cook 1–2 minutes, until the garlic and ginger are fragrant.',
      'Pour in the chicken stock and bring to a simmer. Season with salt and pepper to taste.',
      'Once simmering, add the chicken breasts and fully submerge them in the broth. Cover and simmer for 15 minutes, or until the chicken is cooked through.',
      'Remove the breasts from the pot and shred the chicken.',
      'Stir the spinach in until just wilted, then add the shredded chicken back to the hot soup. Adjust seasoning, adding more salt or pepper if needed.',
      'Serve with lemon wedges. Enjoy!'
    ],
    tips: 'Loaded with turmeric, ginger, and garlic — perfect for fall and winter immune support. A squeeze of lemon at serving brightens it right up.'
  },
  {
    id: 'roasted-zucchini-soup',
    title: 'Roasted Zucchini Soup',
    category: 'soups',
    tags: ['Detox Friendly', 'Green / Love'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/ecnuez4e_42dcaf5f679bd3421b480292cef6740c.jpg',
    description: 'Super simple and super delicious! My fave fastest soup ever!',
    ingredients: [
      '1.5-2 zucchinis per serving, sliced uniformly',
      'Olive oil',
      'Cracked pink salt',
      'Water or stock for desired consistency'
    ],
    instructions: [
      'Place zucchini in a roasting pan or parchment-lined cookie sheet.',
      'Cover with just enough olive oil and cracked pink salt.',
      'Roast near the top of oven at 400-425°F so zucchini can caramelize, approximately 45 minutes.',
      'Place zucchini and liquids into a blender.',
      'Blend, add water or stock for desired consistency.'
    ],
    tips: 'The caramelization is key to the amazing flavor!'
  },
  {
    id: 'carrot-ginger-soup',
    title: 'Carrot Soup with Ginger',
    category: 'soups',
    tags: ['Detox Friendly', 'Orange / Flow', 'Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/zubjh4rx_carrot-ginger-soup-recipe-2217424-hero-5c3e12d6c9e77c0001468ec3.jpg',
    description: 'A warming, anti-inflammatory soup that doubles easily and freezes well.',
    ingredients: [
      '1 medium onion, chopped',
      '1 tablespoon olive oil',
      '8 good-size carrots, peeled and sliced',
      '1 medium sweet potato or squash, cubed',
      '1-2 tablespoons freshly grated ginger',
      '5 cups vegetable or chicken broth',
      'Salt and white pepper to taste',
      'Coconut milk for creamy option'
    ],
    instructions: [
      'Sauté onion in olive oil until translucent. Do not brown.',
      'Add carrots and sweet potato, stir briefly.',
      'Add ginger and broth, bring to boil.',
      'Turn heat to medium-low, cover partly, cook until tender (20-25 minutes).',
      'Purée in blender until smooth.'
    ],
    tips: 'Make ahead and refrigerate. Recipe doubles easily and freezes well.'
  },
  {
    id: 'marias-cleansing-soup',
    title: 'Maria\'s Cleansing Soup',
    category: 'soups',
    tag: 'Detox Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/ueix2l9g_RecipeFb-8-1.jpg',
    description: 'A deeply cleansing soup with beef gelatin for gut healing.',
    ingredients: [
      '3 cups broth (chicken or vegetable)',
      '6 cups water',
      '1 TBS fresh herbs (parsley, thyme, oregano)',
      '3 cloves garlic, peeled',
      '1/3 onion, chopped',
      '2 handfuls frozen green beans',
      '5 stalks celery',
      '3 carrots (omit if diabetic)',
      '10 radishes',
      '2 TBS beef gelatin (optional)'
    ],
    instructions: [
      'Pour water and broth into a pot.',
      'Wash and chop vegetables, add to pot.',
      'Bring to boil, then simmer for 20 minutes.',
      'Add beef gelatin just before blending.',
      'Liquify with hand blender or regular blender.'
    ],
    tips: 'Beef gelatin is healing for the intestinal tract, great for skin, hair, nails and joints!'
  },
  {
    id: 'spring-pea-soup',
    title: 'Spring Pea Soup',
    category: 'soups',
    tags: ['Detox Friendly', 'Green / Love', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1626200419199-391ae4be7a41?w=600',
    description: 'A fresh, vibrant soup that\'s delicious cold in summer or warm in winter.',
    ingredients: [
      '10 oz fresh or frozen raw peas',
      '1 medium avocado',
      '1 cup filtered water or homemade stock',
      '1 cup almond milk',
      '2 tbsp lime juice',
      'Pinch sea salt',
      '1/2 tsp chilli powder (optional)'
    ],
    instructions: [
      'In a blender, puree all ingredients until smooth.',
      'Drizzle with olive oil and freshly ground black pepper to serve.'
    ],
    tips: 'The avocado makes this incredibly creamy without any dairy.'
  },
  {
    id: 'mexican-chicken-lime-soup',
    title: 'Mexican Chicken Lime Soup',
    category: 'soups',
    tags: ['Gluten Free', 'Yellow / Fire'],
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_f11ad4fb-d6a4-4f13-b6d9-cc4ad6bfdd79/artifacts/0lxspazx_IMG_5299.webp',
    description: "I call this my 'sick soup.' When we were kids and got sick, it was toast and honey — and one of those Lipton chicken noodle soup packs! Not the instant kind, but the one that made about 4 cups of soup and was nearly fluorescent yellow! I used to add garlic thinking it was helping me fight my sick. That probably was — but the yellow was just weird, looking back. It's amazing I'm alive! So when I went gluten free, getting sick was a real drag, because what the heck could I eat? It's like you're not hungry but sort of hungry. You don't want overly tasty food, you want comforts — and I couldn't have any. And nearly 20 years ago, gluten-free bread was a disaster! So none of that. Then enter Mexican Chicken Lime Soup! I had it at a friend's place once and it was divine. And I thought — wow, this ticks all the boxes for getting well. Chicken soup. It's real. Citrus — good for me! Garlic — also good for sick. Broth — soothing! Nailed it! I eat it because it's delish, but I was so thankful to finally have an adequate 'home sick' soup to soothe my weary soul when I crawl under the blankets, under the weather.",
    servings: '4 servings',
    ingredients: [
      '2 tbsp butter, divided',
      '4 boneless skinless chicken breasts',
      '1 cup chopped onion',
      '2 cloves garlic, minced',
      '2 tomatoes, seeded and chopped',
      '6 cups chicken broth (preferably homemade — see my recipe, or use yours)',
      '½ cup freshly squeezed lime juice (4 to 5 limes)',
      '2 cups broken corn tortilla chips',
      '2 avocados, diced',
      '4 green onions, green parts only, minced',
      'Hot pepper, for a spicy version (optional — not anti-inflammatory)',
      'Salt and pepper, to taste',
      'Cilantro and olive oil (EVOO), optional, as garnish',
    ],
    instructions: [
      'In a large skillet, heat 1 tbsp of the butter over medium-high heat.',
      'Add the chicken and cook, turning once, until no longer pink inside — about 6 to 8 minutes per side.',
      'Transfer the chicken to a cutting board and let cool.',
      'In a large pot, heat the remaining butter over medium heat. Add the onion and garlic. Cover and cook until the onion is softened, 4 to 6 minutes.',
      'Add the chicken broth and lime juice.',
      'Dice the chicken and add it to the pot. Cover and bring to a boil over medium heat. Reduce heat to low and simmer for 10 minutes.',
      'Ladle into individual bowls and garnish with equal amounts of fresh tomato, tortilla chips, avocado and green onion (plus cilantro and a drizzle of olive oil, if using). Keeping the tomatoes raw keeps them fresh and bright.',
    ],
    tips: 'Ticks all the boxes for getting well: real chicken soup, citrus, garlic and soothing broth. Homemade broth makes it extra nourishing when you\'re under the weather.'
  },

  {
    id: 'creamy-leek-carrot-soup',
    title: 'Creamy Leek and Carrot Soup',
    category: 'soups',
    tags: ['CRAP Cleanse Friendly', 'Orange / Flow', 'Green / Love'],
    image: 'https://images.unsplash.com/photo-1476718406336-bb5a9690ee2a?w=600',
    description: 'A smooth, creamy soup that\'s perfect for cold days.',
    ingredients: [
      '1 leek, chopped',
      '2 tbsp coconut oil',
      '4 cups chopped carrots',
      '1 cup cauliflower florets',
      '1.5 quarts chicken or veg stock',
      'Fresh thyme',
      'Optional: 1/4–1/2 cup coconut milk (for extra creaminess)'
    ],
    instructions: [
      'Melt coconut oil, add leek and cook 3-4 minutes.',
      'Add carrots, cook another 3-4 minutes.',
      'Pour in stock, cover and simmer 15 minutes.',
      'Puree with additional coconut oil until smooth.',
      'For an extra-creamy soup, stir in 1/4–1/2 cup coconut milk at the end.',
      'Reheat and serve warm.'
    ],
    tips: 'In summer, skip reheating and chill for a cold soup!'
  },
  {
    id: 'avgolemono-soup',
    title: 'Avgolemono Soup',
    category: 'soups',
    tags: ['Detox Friendly', 'Red / Root', 'Yellow / Fire', 'Blue / Truth'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/eu2indra_avgo%20soup.jpg',
    description: 'A delicious Greek lemon chicken soup - warm and satisfying!',
    ingredients: [
      '2 Tbsp olive oil',
      '1 cup chopped onion',
      '5 cups chicken stock + 1 cup water',
      '1/2 cup brown rice (cooked)',
      '1 pound chicken breast, diced',
      '3 Tbsp lemon juice',
      '3 eggs',
      'Fresh parsley'
    ],
    instructions: [
      'Sauté onions until soft and translucent.',
      'Add stock and bring to simmer.',
      'Add cooked rice and diced chicken, cook 5-8 minutes.',
      'Beat eggs and whisk in lemon juice.',
      'Temper eggs with hot broth, then add back to soup.',
      'Serve with parsley.'
    ],
    tips: 'Add extra veg like carrot and celery. Use pre-cooked brown rice for speed.'
  },

  // ============ MAINS ============
  {
    id: 'almond-salmon-swiss-chard',
    title: 'Almond Salmon with Swiss Chard',
    category: 'mains',
    tags: ['Detox Friendly', 'Green / Love'],
    image: 'https://static.prod-images.emergentagent.com/jobs/ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/images/815606ecd83b0c91d5f065ca97983f939874600c0b1c6cbdaeda46f767ffbcd4.png',
    description: 'Tender wild salmon under a golden almond-meal crust, served over garlicky, balsamic-kissed Swiss chard. A nourishing, heart-loving dinner that supports The Love. Serves 2 — save a fillet for tomorrow\'s lunch.',
    servings: '2 servings',
    time: 'Prep 10 min · Bake 15–20 min',
    ingredients: [
      '2 tablespoons almond meal (grind your own almonds in a blender)',
      '2 tablespoons extra-virgin olive oil, divided',
      '2 wild-caught salmon fillets (3–4 oz each)',
      '1 garlic clove, minced',
      '1 small bunch Swiss chard (about 5 large leaves), stemmed and roughly chopped',
      '1 tablespoon balsamic vinegar',
      'Sea salt and ground black pepper, to taste',
    ],
    instructions: [
      'Preheat the oven to 375°F.',
      'In a small bowl, combine the almond meal with 1 tablespoon of the olive oil. Spread the almond paste over both salmon fillets, set them in a glass baking dish, and bake 15–20 minutes, until just cooked through.',
      'Meanwhile, warm the remaining tablespoon of olive oil in a sauté pan over medium heat. Add the garlic and cook about 1 minute.',
      'Add the chard and cook until it wilts, about 3–4 minutes. Toss with the balsamic vinegar, and season with salt and pepper to taste.',
      'Arrange the chard on a plate, top with a salmon fillet, and enjoy warm. Save the second fillet for tomorrow\'s lunch.',
    ],
    tips: 'Grinding your own almond meal keeps it fresh. The chard and salmon both love The Love — omega-rich and mineral-dense.'
  },
  {
    id: 'rosemary-roasted-cauliflower-tahini',
    title: 'Rosemary-Roasted Cauliflower with Spinach & Tahini',
    category: 'mains',
    tags: ['Detox Friendly', 'Green / Love'],
    image: 'https://static.prod-images.emergentagent.com/jobs/ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/images/0988d6f2b24a91d5cdcf9c5b1c3e97bc47826ccf333ef04cf9a64865ad2e9895.png',
    description: 'Fragrant rosemary-roasted cauliflower with toasted pine nuts over a bed of spinach, finished with a creamy tahini drizzle. A cozy, plant-based main for The Love. Serves 2 — save half for tomorrow\'s lunch.',
    servings: '2 servings',
    time: 'Prep 10 min · Roast 20–25 min',
    ingredients: [
      '3 cups chopped cauliflower',
      '2 garlic cloves, minced',
      '1 tablespoon extra-virgin olive oil',
      '2 teaspoons dry rosemary powder',
      '2 tablespoons raw pine nuts',
      'Sea salt and freshly ground black pepper, to taste',
      '2 large handfuls spinach (about 3 cups)',
      '1 tablespoon tahini',
      'Optional for omnivores: add grilled chicken, steak, or your desired protein',
    ],
    instructions: [
      'Preheat the oven to 425°F.',
      'In a large bowl, toss the cauliflower with the garlic and olive oil until well coated. Sprinkle with the rosemary and pine nuts, and season with salt and pepper.',
      'Spread the cauliflower evenly on a baking sheet and roast, uncovered, 20–25 minutes, until the tops and edges are lightly browned.',
      'Serve half the cauliflower over fresh or lightly wilted spinach, and drizzle everything with tahini. Save the other half for tomorrow\'s lunch.',
      'For omnivores, add grilled chicken, steak, or your desired protein alongside.',
    ],
    tips: 'Lovely as a vegan main, or add grilled chicken, steak, or your favourite protein to make it heartier. The tahini drizzle ties it all together.'
  },
  {
    id: 'orange-sesame-stir-fry',
    title: 'Orange Sesame Stir-Fry',
    category: 'mains',
    tags: ['Orange / Flow', 'Yellow / Fire', 'Red / Root', 'Green / Love'],
    image: 'https://customer-assets.emergentagent.com/job_1e935ed4-0433-457e-9559-d73f82154bb5/artifacts/ape7v8bn_Homemade-Teriyaki-Chicken-Stir-Fry-with-Rice-500x500.jpg',
    description: 'This Orange Sesame Stir-Fry is simple and tasty as a vegetarian or protein meal. A flavorful, easy-to-make orange-sesame sauce comes together in just minutes.',
    servings: '4 servings',
    ingredients: [
      '2 chicken breasts (or protein of choice)',
      '2 tablespoons butter (or cooking oil of choice)',
      '1/2 cup fresh orange juice',
      'Zest of one orange',
      '1 tablespoon wild honey',
      '4 tablespoons tamari / coconut aminos',
      '1 tablespoon freshly grated ginger',
      '1 tablespoon toasted sesame oil',
      '3 cloves garlic, minced',
      '1 tablespoon cornstarch',
      '1 bell pepper, sliced',
      '1 bunch broccoli, chopped',
      '3 ounces shiitake mushrooms, sliced',
      '1 tablespoon toasted sesame seeds (plus more for serving)',
      'Brown rice, quinoa, or riced cauliflower, for serving'
    ],
    instructions: [
      'Marinate your protein, then brown or grill it. For chicken: 1 tablespoon sesame oil + 1 tablespoon tamari/aminos. For steak: salt and pepper.',
      'In the meantime, make the sauce. Combine the tamari, sesame oil, orange juice and zest, honey, ginger, minced garlic, and cornstarch. Whisk well and set aside.',
      'Heat 1 tablespoon of oil in a skillet until hot. Cut the chicken/steak into small cubes and sauté until golden and crispy. Remove from the pan and set on paper towels to drain.',
      'Add the other tablespoon of oil to the pan. Add the bell pepper, broccoli, and shiitake mushrooms. Season with salt and pepper and cook until the vegetables are softened but still have a slight crunch.',
      'Whisk the sauce once more to incorporate, then add the sauce and the protein back to the pan. Cook until the sauce bubbles and thickens. Stir in the toasted sesame seeds.',
      'Serve the stir-fry over your choice of rice, quinoa, or cauliflower, and top with additional toasted sesame seeds and a drizzle of toasted sesame oil.'
    ],
    tips: 'Make it fully plant-based by swapping the chicken for tofu, tempeh, or extra mushrooms and chickpeas. The orange juice and zest feed The Flow, while ginger, garlic, and sesame bring warming digestive fire.'
  },
  {
    id: 'steak-blistered-tomatoes',
    title: 'Steak with Blistered Tomatoes',
    category: 'mains',
    tags: ['Gluten Free', 'Red / Root'],
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_f11ad4fb-d6a4-4f13-b6d9-cc4ad6bfdd79/artifacts/auej88qt_IMG_5213.jpeg',
    description: 'A grounding, deeply nourishing plate for The Root — grass-fed steak, vine tomatoes blistered until sweet and juicy, peppery arugula, shavings of Parmesan, and a generous pour of the resting juices. Simple, mineral-rich, and quietly luxurious.',
    ingredients: [
      '--- BLISTERED TOMATOES ---',
      '500 g (1 lb) vine tomatoes',
      '1 tbsp olive oil',
      '2 tbsp balsamic vinegar',
      '1 tsp salt',
      '--- GRILLED STEAK ---',
      '800 g (1½ lbs) steak of your choice',
      '2 tbsp olive oil',
      '2 tbsp lemon juice',
      '2–3 tsp flaky sea salt',
      'Black pepper, to taste',
      '--- TO SERVE ---',
      'Parmesan cheese, shaved',
      'Fresh rocket / arugula',
      'Lemon wedges',
    ],
    instructions: [
      'Mix the olive oil, balsamic vinegar, and salt together and pour over the tomatoes.',
      'Drizzle the olive oil and lemon juice over the steak then season generously with salt and pepper. (This step can be done up to 24 hours ahead.)',
      'Pre-heat a grill or grill pan, then add the steak and tomatoes. If your pan/grill isn\'t big enough, cook the steak first then grill the tomatoes while the steak is resting.',
      'Cook the steak to your preference, then remove from heat and let it rest, covered with foil, for at least 5 minutes.',
      'Remove the tomatoes from the grill once they\'re blistered. Place them in a bowl or dish so none of their juices go to waste.',
      'Slice the rested steak and serve on rocket / arugula with the tomatoes and Parmesan shavings. Pour over the resting juices of both the steak and the tomatoes.',
    ],
    tips: 'Grass-fed beef is mineral-dense and rich in iron — a true Root food. Let the steak rest properly so the juices stay in the meat, then pour them back over the salad at the end. Those juices are flavour gold. For an extra-grounding plate, add a side of roasted root vegetables or a small serving of bone broth on the side.',
  },
  {
    id: 'grilled-salmon-veggies',
    title: 'Grilled Salmon with Steamed Veggies',
    category: 'mains',
    tags: ['Detox Friendly', 'Red / Root', 'Indigo / Insight', 'Green / Love'],
    image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=600',
    description: 'A healthy, tasty dish that\'s ready in just 15 minutes.',
    ingredients: [
      '1 lb salmon',
      '1 TBS fresh lemon juice',
      '3 cups baby spinach',
      '1 cup green string beans',
      '2 cups snow peas',
      '1/2 cup chopped scallion',
      '2 TBS chopped cilantro',
      '1 tsp toasted sesame seeds'
    ],
    instructions: [
      'Steam vegetables for 3 minutes and set aside.',
      'Whisk together dressing: lemon juice, olive oil, sesame oil, honey, five spice.',
      'Rub salmon with lemon juice, season with salt and pepper.',
      'Grill salmon for about 10 minutes.',
      'Sprinkle with sesame seeds and serve with vegetables.'
    ],
    tips: 'The dressing is low in fat and grilling requires no additional oils.'
  },
  {
    id: 'roasted-chicken-root-veg',
    title: 'Roasted Chicken and Root Vegetables',
    category: 'mains',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow'],
    image: 'https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=600',
    description: 'A classic comfort meal with healing bone broth potential.',
    ingredients: [
      'Whole chicken, washed',
      '1 onion, chopped',
      'Garlic',
      'Fresh herbs (sage, rosemary)',
      'Lemon',
      'Salt and pepper',
      'Ghee or olive oil',
      'Root vegetables (carrots, parsnips, sweet potato, celery)'
    ],
    instructions: [
      'Wash chicken thoroughly.',
      'Stuff cavity with garlic, onions, lemon, and herbs.',
      'Separate skin from breast and stuff herbs between skin and meat.',
      'Season liberally with salt and pepper.',
      'Drizzle with ghee or olive oil.',
      'Surround with chopped root vegetables.',
      'Roast according to weight.'
    ],
    tips: 'Roasting times: 2.5-3 lbs = 1-1.75 hrs, 3.5-4 lbs = 1.5-1.75 hrs, 4.5-5 lbs = 1.5-2 hrs'
  },
  {
    id: 'cauliflower-black-bean-bowl',
    title: 'Cauliflower Black Bean Bowl',
    category: 'mains',
    tags: ['Detox Friendly', 'Red / Root', 'Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/5bopee6u_Cauliflower-Black-Bean-Bowl-with-Kale-Guacamole-min-1024x780.jpg',
    description: 'A quick and easy dinner with kale guacamole that also makes a great snack.',
    ingredients: [
      '1 small head cauliflower',
      '2 tablespoons olive oil',
      '3 scallions, sliced',
      '2 garlic cloves, chopped',
      '1/2 teaspoon cumin',
      '1 cup black beans',
      'Cilantro and lime for serving'
    ],
    instructions: [
      'Pulse cauliflower in food processor until couscous-sized.',
      'Make guacamole: mash avocado with onion, cilantro, lime, salt, and blanched kale.',
      'Sauté cauliflower with scallions, garlic, and cumin.',
      'Serve cauliflower with black beans and guacamole.'
    ],
    tips: 'The kale guacamole makes a great snack with raw veggies!'
  },
  {
    id: 'spicy-chicken-salad',
    title: 'Spicy Chicken Salad',
    category: 'mains',
    tags: ['Detox Friendly', 'Red / Root', 'Yellow / Fire', 'Green / Love'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/e3w2fmng_Grounded%20Wellness%20%28Logo%29%20%287%29.png',
    description: 'A flavorful chicken salad dressed with olive oil and coconut milk.',
    ingredients: [
      '2 cups chicken',
      '2-3 cups chopped celery, onion, carrot',
      '1/2 c cilantro or parsley',
      '1/4-1/2 c olive oil',
      '1/4-1/2 c coconut milk',
      'Chopped hot pepper',
      'Salt and pepper',
      '1/4-1/2 avocado'
    ],
    instructions: [
      'Combine chicken and vegetables, add cilantro.',
      'Mash hot pepper with olive oil, salt and pepper.',
      'Pour oil over chicken, add coconut milk to coat.',
      'Add fresh avocado when ready to eat.'
    ],
    tips: 'Take out of fridge 10 minutes before eating so coconut milk softens. Keeps for several days.'
  },
  {
    id: 'salmon-steak',
    title: 'Salmon Steak',
    category: 'mains',
    tags: ['Detox Friendly', 'Red / Root', 'Indigo / Insight'],
    image: 'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=600',
    description: 'A simple, flavorful baked salmon with Asian-inspired marinade.',
    ingredients: [
      '4 salmon steaks',
      '2 tablespoons tamari (gluten free)',
      '3 tablespoons grape seed or groundnut oil',
      'Juice of 1 lemon',
      '1 tablespoon grated ginger',
      '1 clove garlic',
      'Black pepper',
      '1 tablespoon honey (optional)'
    ],
    instructions: [
      'Arrange salmon on baking sheet.',
      'Mix marinade ingredients and pour over salmon.',
      'Marinate for up to 4 hours.',
      'Bake at 350°F for about 20 minutes.'
    ],
    tips: 'The longer you marinate, the more flavorful!'
  },
  {
    id: 'socca-tacos',
    title: 'Grilled Zucchini Socca Tacos',
    category: 'mains',
    tags: ['Detox Friendly', 'Red / Root', 'Green / Love'],
    image: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=600',
    description: 'Vegan tacos so satisfying you won\'t miss corn or wheat tortillas.',
    ingredients: [
      '1 cup + 2 tbsp garbanzo bean flour',
      '1 cup water',
      '1 large zucchini',
      '1 cup black beans',
      '1/2 avocado',
      'Cabbage slaw with tahini dressing',
      'Cilantro, lime, jalapeño for garnish'
    ],
    instructions: [
      'Make socca batter with flour, water, oil, salt. Let sit 15 min.',
      'Cook small pancakes in hot pan, 1-2 min per side.',
      'Bake socca in muffin tin for crispy shells.',
      'Grill zucchini with cumin and salt.',
      'Assemble with beans, zucchini, avocado, and garnish.'
    ],
    tips: 'Use lettuce leaves as taco shells for even easier prep!'
  },

  // ============ ESSENTIALS ============
  {
    id: 'homemade-chicken-stock',
    title: 'Homemade Chicken Stock / Bone Broth',
    category: 'soups',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/8c88zt03_Bone-Broth-e1562715662727.webp',
    description: 'Healing for the gut and digestion. Boxed stocks are virtually devoid of nutrients - make your own!',
    ingredients: [
      'Chicken bones, carcass, skin',
      '2 each carrots and celery, rough chopped',
      '1 onion, rough chopped',
      '1 tsp vinegar or lemon juice',
      '6-8 cups filtered water',
      'Herbs: rosemary, sage, basil, oregano, bay',
      'Pink salt and peppercorns'
    ],
    instructions: [
      'After roasting chicken, put bones back in pan at high heat for 15 minutes until browned.',
      'Add vegetables, herbs, salt, pepper.',
      'Cover with cold water (6+ cups).',
      'Cook at high heat until almost boiling, then reduce to 300-350°F for 1-3 hours.',
      'Halfway through, break bones open for marrow.',
      'Strain and store in glass jars.'
    ],
    tips: 'Can cook up to 24 hours for maximum nutrition. Ask your butcher for bones - they sell them cheaply! Cool quickly and use within one week.'
  },
  {
    id: 'essential-brown-rice',
    title: 'My Essential Brown Rice Method',
    category: 'essentials',
    tag: 'Detox Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/yurie9y4_R.jpg',
    description: 'The perfect method for fluffy, flavorful brown rice every time.',
    ingredients: [
      '1 cup brown rice (long grain, basmati, red, or wild)',
      '2 cups homemade chicken stock or water (heated)',
      '1/2 cup chopped onion or leek',
      '1 tsp ghee or coconut oil'
    ],
    instructions: [
      'Sauté onions or leeks in oil until soft.',
      'Add brown rice and sauté until caramelized, about 1-2 minutes.',
      'Transfer to casserole dish, add hot liquid.',
      'Cover tightly and bake for 1 hour at 375°F.'
    ],
    tips: 'Add spices like cumin, Italian seasonings, oregano, or cardamom to change the flavor.'
  },
  {
    id: 'herb-oil',
    title: 'Herb Oil',
    category: 'essentials',
    tag: 'Detox Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/ytd1xvgv_herbs-oil-1024x629.jpg',
    description: 'A quick go-to for adding fresh herb flavor to any dish.',
    ingredients: [
      'Finely chopped assorted herbs (basil, sage, chives, rosemary, oregano)',
      'Olive oil (enough to cover herbs)',
      'Coarse sea salt'
    ],
    instructions: [
      'Finely chop assorted herbs.',
      'Store in a glass container.',
      'Cover with enough oil so all herbs are covered.',
      'Add coarse sea salt.'
    ],
    tips: 'Keeps in fridge for a couple weeks. Great on vegetables, meats, fish, avocado. The basil will darken but that\'s okay!'
  },
  {
    id: 'chimichurri',
    title: 'Chimichurri',
    category: 'essentials',
    tag: 'Detox Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/jw6yvw63_chimichurri-14.jpg',
    description: 'A vibrant, herbaceous sauce perfect as a dipping sauce for breads and vegetables, marinade, or finish for grilled meats and fish. Makes 1 cup.',
    servings: '1 cup',
    ingredients: [
      '1 bunch parsley',
      '1 bunch cilantro',
      '2 tablespoons finely minced garlic',
      '2 teaspoons chile flakes',
      '1 teaspoon salt',
      '1 teaspoon pepper',
      '1/4 cup lemon juice',
      '1/4 cup red wine vinegar',
      '1 cup extra-virgin olive oil'
    ],
    instructions: [
      'When washing parsley and cilantro, shock them in chilled water to remove debris and make chopping easier. Submerge in ice-cold bath, remove and wrap in absorbent towels to blot liquid.',
      'Remove large stems and tips from herbs.',
      'Chop parsley and cilantro together in a food processor (without overprocessing) or by hand. Processing allows flavors to release into the acidic mixture even more.',
      'Place in a bowl with all the other ingredients and combine.',
      'Best when made 24 hours in advance.'
    ],
    tips: 'EVOO coagulates when refrigerated. Two solutions: (1) always serve at room temperature, or (2) use a blended olive oil with grapeseed oil for a lighter version - great as a marinade or finish for delicate grilled fish and seafood. Using EVOO makes a richer chimichurri for dipping sauce.'
  },
  {
    id: 'leilas-cell-food',
    title: "Leila's Cell Food",
    category: 'essentials',
    tag: 'Detox Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/y0ul6oyj_Basil-Peso-How-To-Make-and-Freeze_1658-300x300.jpg',
    description: 'A vibrant, nutrient-dense herb blend packed with fresh greens. Perfect for adding to smoothies, spreading on toast, or using as a sauce.',
    ingredients: [
      '3 cups or more of fresh herbs, stems and all (bulk parsley, plus any combination of basil, oregano, rosemary, watercress, mustard greens)',
      '¾ cup olive oil, plus more if needed for consistency and blending',
      '2-3 tbsp coconut vinegar, or less of apple cider vinegar, or lemon or lime juice',
      '1 medium carrot',
      'Pink salt and fresh cracked pepper to taste (or Celtic, grey, red, black, any mine salt)'
    ],
    instructions: [
      'Wash and roughly chop all fresh herbs, keeping stems attached for extra nutrition.',
      'Peel and chop the carrot into chunks.',
      'Add herbs, carrot, olive oil, and vinegar to a blender or food processor.',
      'Blend until smooth, adding more olive oil if needed for consistency.',
      'Season with salt and pepper to taste.',
      'Store in an airtight container in the refrigerator.'
    ],
    tips: 'Use any combination of herbs you enjoy - the beauty of this recipe is its flexibility. The carrot adds natural sweetness and extra nutrients.'
  },
  {
    id: 'veg-healing-broth',
    title: 'Veg Healing Broth',
    category: 'soups',
    tags: ['Detox Friendly', 'Rainbow / All Systems'],
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/q5w6h6pm_Winter-Vegetable-Soup-7-683x1024.jpg',
    description: 'A nourishing vegetable broth slow-cooked with healing herbs and spices. Perfect as a soup base or enjoyed as a restorative drink 1-3 cups per day.',
    ingredients: [
      '4 cloves of garlic',
      '1 inch knob of ginger',
      '6 mushrooms',
      '10 oz (250 grams) of cabbage',
      '4 carrots',
      '4 celery stalks',
      'A pinch of black pepper',
      '1 teaspoon or inch of ground turmeric',
      '1 tablespoon of organic virgin coconut oil',
      '1 tablespoon of miso paste (optional)',
      'Handful of any herbs - parsley, rosemary, thyme, 1-2 bay leaves',
      'Optional extras: burdock, oregano, etc.',
      'Couple slices of lemon (added near the end)'
    ],
    instructions: [
      'Place all ingredients (except fresh herbs and lemon) in a crock pot and fill with quality water.',
      'Cook on low for 8-12 hours.',
      'Add fresh herbs and lemon slices close to being finished.',
      'Strain all ingredients through a fine mesh strainer.',
      'Place broth in jars and store in the fridge, or freeze.',
      'If freezing, be sure to leave plenty of space at the top or your jars will break.',
      'Enjoy as a soup base or as a healing drink 1-3 cups per day.'
    ],
    tips: 'The longer you cook this broth, the more nutrients are extracted from the vegetables. You can customize with any healing herbs or vegetables you have on hand.'
  },
  {
    id: 'mashed-cauliflower',
    title: 'Mashed Cauliflower',
    category: 'essentials',
    tags: ['Detox Friendly', 'Green / Love', 'Orange / Flow'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/kw11geu6_Garlic-Herb-Mashed-Cauliflower-V1.jpg',
    description: 'A great substitute for mashed potatoes!',
    ingredients: [
      '8 cups cauliflower florets (about 1 head)',
      '4 cloves garlic, crushed',
      '1/3 cup coconut, almond or rice milk',
      '4 teaspoons olive oil',
      '1 teaspoon butter',
      'Salt and pepper',
      'Fresh chives (optional)'
    ],
    instructions: [
      'Steam cauliflower and garlic for 12-15 minutes until very tender.',
      'Place in food processor with milk, 2 tsp oil, butter, salt and pepper.',
      'Pulse then process until smooth and creamy.',
      'Drizzle with remaining oil and chives.'
    ],
    tips: 'Can roast cauliflower in tinfoil at 375-400°F for 30-40 min for a different flavor.'
  },
  {
    id: 'brown-rice-pulao',
    title: 'Brown Rice Pulao',
    category: 'essentials',
    tags: ['Detox Friendly', 'Red / Root', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1596560548464-f010549b84d7?w=600',
    description: 'A popular Indian rice dish with aromatic spices.',
    ingredients: [
      '2 cups brown basmati rice',
      '3 tablespoons ghee or avocado oil',
      '1 tablespoon cumin seeds',
      '10 whole cloves',
      '5 cardamom pods',
      '2 bay leaves',
      '1 cinnamon stick',
      '4 cups water',
      '2 cups frozen vegetables',
      '1/4-1/2 cup raisins (optional)'
    ],
    instructions: [
      'Wash rice and set aside.',
      'Heat ghee, add spices and stir (don\'t burn).',
      'Add rice, stir 8 minutes.',
      'Add water, bring to boil, cover, cook 45-55 minutes.',
      'Stir in frozen vegetables and raisins.',
      'Remove large spices before serving.'
    ],
    tips: 'Serves 8 people - great for meal prep!'
  },
  {
    id: 'charred-corn-avocado-salsa',
    title: 'Charred Corn & Avocado Salsa',
    category: 'essentials',
    tags: ['Detox Friendly', 'Yellow / Fire', 'Green / Love'],
    image: 'https://images.unsplash.com/photo-1602881916963-5daf2d97c06e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'A chunky-style salsa with grilled or broiled charred corn and ripe avocado. So good topped on tacos or with good tortilla chips!',
    servings: 'About 4 cups',
    time: 'Prep 5 min · Cook 15 min · Total 25 min',
    ingredients: [
      '3 ears sweet corn, charred',
      '3 tablespoons olive oil, or more if needed',
      '2 large avocados, slightly underripe',
      '1/4 large red onion, diced',
      '1 medium jalapeno or chili pepper',
      '2 cups grape tomatoes, charred',
      '2 tablespoons cilantro, minced',
      '1-2 medium limes, juiced',
      '1 teaspoon kosher salt, or to taste',
      '1 teaspoon cracked pepper',
      'Tortilla chips, for serving'
    ],
    instructions: [
      'Preheat grill to high heat, or preheat your oven to broil. Rub corn lightly with oil and season with a sprinkle of salt. Add corn to the grill or place under the broiler for 3-4 minutes until charred. Turn and cook for another 2-3 minutes. Remove corn and let cool slightly.',
      'When corn is cool enough to handle, slice off the kernels into a medium mixing bowl. Dice the avocado into small cubes and stir into the corn.',
      'Add the red onion, charred tomatoes, jalapeno, and cilantro and stir to combine. Then add the lime juice, salt, and pepper. Stir well and taste, adjusting seasoning to your liking.',
      'Serve salsa with tortilla chips.'
    ],
    tips: 'Store leftover salsa in the fridge in an airtight container for 3-4 days.'
  },


  // ============ DRESSINGS ============
  {
    id: 'lemon-dressing',
    title: 'Lemon Vinaigrette Base',
    category: 'dressings',
    tag: 'Detox Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/apyn9fgp_download.webp',
    description: 'A simple base dressing with citrus clarifying properties.',
    ingredients: [
      'Lemon juice (1/2 - 1 tbsp)',
      'Olive oil (2x the lemon juice)',
      'Salt and pepper to taste'
    ],
    instructions: [
      'Whisk all ingredients together.',
      'Add optional flavors: dry mustard, honey, stevia, tahini, fresh herbs, carrot juice, or sesame oil.'
    ],
    tips: 'Stick to lemon and lime with olive oil as often as possible - citrus has a clarifying aspect.'
  },
  {
    id: 'lime-dressing',
    title: 'Lime Vinaigrette Base',
    category: 'dressings',
    tag: 'Detox Friendly',
    image: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=600',
    description: 'A zesty lime dressing perfect for salads.',
    ingredients: [
      'Juice of 2 limes',
      'Equal amount olive oil',
      'Coarse sea salt',
      'Cracked pepper'
    ],
    instructions: [
      'Pour all ingredients directly onto salad.',
      'Toss well and serve.'
    ],
    tips: 'The salt balances the lime juice perfectly.'
  },
  {
    id: 'tahini-dressing',
    title: 'Creamy Tahini Dressing',
    category: 'dressings',
    tag: 'Detox Friendly',
    image: 'https://static.prod-images.emergentagent.com/jobs/ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/images/5e30cbb1353167b8869aab7c5c9a3359dc432ce86aa196df28f78a31f2a6f501.png',
    description: 'A smooth, garlicky tahini dressing brightened with lemon and apple cider vinegar. Best on green salads with Mediterranean flavors. Whisk together in minutes.',
    ingredients: [
      '1/4 cup tahini (I used Trader Joe\'s)',
      '2 tablespoons fresh lemon juice',
      '1 tablespoon apple cider vinegar',
      '2 cloves garlic, minced',
      '1 tablespoon pure maple syrup',
      'Salt and pepper to taste',
      '1/4 cup water, to thin'
    ],
    instructions: [
      'Pour all ingredients into a small bowl or jar.',
      'Whisk together until smooth.',
      'If the tahini flavor is too strong for your taste, add a bit more apple cider vinegar and maple syrup to taste.',
      'Store in the refrigerator, or use on salads immediately.'
    ],
    tips: 'I like this tahini dressing best on green salads with Mediterranean flavors. Thin with a little extra water if it firms up in the fridge.'
  },
  {
    id: 'homemade-mayo',
    title: 'Homemade Mayonnaise',
    category: 'dressings',
    tag: 'Detox Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/td7k72y7_4-Ingredient-Homemade-Mayonnaise-Recipe-For-Beginners-1.jpg',
    description: 'So much wiser than store-bought! A healthy fat-rich condiment.',
    ingredients: [
      '3 egg yolks',
      '1 teaspoon dijon or dry mustard',
      'Pinch of quality salt',
      'Pinch of freshly ground pepper',
      '1 lemon',
      '1 1/4 cups olive oil'
    ],
    instructions: [
      'Put egg yolks in food processor with mustard, turn on.',
      'SLOWLY pour oil in during first 30 seconds - this is crucial!',
      'After 30 seconds, pour faster.',
      'Turn off, add salt and pepper.',
      'Squeeze in lemon juice, pulse briefly.'
    ],
    tips: 'Can whisk by hand but a food processor is much easier. Store in fridge.'
  },
  {
    id: 'apple-cider-vinaigrette',
    title: 'Raw Apple Cider Vinaigrette',
    category: 'dressings',
    tag: 'CRAP Cleanse Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/1694o4lq_apple-cider-vinaigrette_thecozyapron_3.jpg',
    description: 'A tangy, probiotic-rich dressing that supports digestion.',
    ingredients: [
      '1 garlic clove, minced',
      '1 tablespoon dry mustard',
      '1/4 cup raw apple cider vinegar',
      '2 tablespoons fresh lemon juice',
      '1-2 tablespoons raw honey',
      '1/3 cup extra-virgin olive oil',
      'Salt and pepper'
    ],
    instructions: [
      'Combine all ingredients in a glass mason jar.',
      'Seal and shake until honey dissolves.',
      'Let marinate 30 minutes before serving.',
      'Store in fridge up to a week.'
    ],
    tips: 'Shake well before each use!'
  },
  {
    id: 'horseradish-vinaigrette',
    title: 'Horseradish Vinaigrette',
    category: 'dressings',
    tag: 'CRAP Cleanse Friendly',
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/2s1xhwat_creamy-vinaigrette-1-2.webp',
    description: 'A zesty dressing perfect for roasted root vegetables.',
    ingredients: [
      '3 tbsp cider vinegar',
      '2 tbsp grated fresh horseradish',
      '1 tbsp Dijon mustard (dry mustard on cleanse)',
      '1 tbsp homemade mayonnaise (optional)',
      '1 tsp maple syrup or honey',
      '1 tsp chopped garlic',
      '1/2 cup olive oil',
      'Salt and pepper'
    ],
    instructions: [
      'Whisk together vinegar, horseradish, mustard, mayo, syrup, and garlic.',
      'Slowly whisk in olive oil.',
      'Season with salt and pepper.'
    ],
    tips: 'Fresh horseradish is SO worth it! Keeps for several weeks in the fridge.'
  },
  {
    id: 'cloned-catalina-dressing',
    title: 'Cloned Catalina Dressing',
    category: 'dressings',
    tag: '',
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/kxqkspkc_df55f0af12d7b234a2cc5b530c54c3b1.png',
    description: 'A healthier homemade version of the store-bought classic - no hidden inflammatory seed oils or problematic sweeteners! This zippy number goes on taco salad and is really comfort food made healthier.',
    ingredients: [
      '1 cup granulated sugar (cut back a wee bit to your taste)',
      '2 teaspoons salt',
      '1/2 teaspoon paprika',
      '1 teaspoon chili powder',
      '1/2 teaspoon celery seed',
      '1/2 teaspoon dry mustard',
      'Grated onion, to taste',
      '1/2 cup apple cider vinegar (for healthy probiotic boost)',
      '2/3 cup ketchup (try to find healthy, organic ketchups with no high fructose corn syrup)',
      '1 cup extra-virgin olive oil (EVOO)'
    ],
    instructions: [
      'Combine all dry ingredients in a bowl or blender.',
      'Add vinegar and ketchup.',
      'Slowly blend in olive oil until well combined.',
      'Store in fridge for several weeks...if it lasts that long!'
    ],
    tips: 'I love to replicate store-bought faves so I know exactly what I\'m eating with no hidden surprises. Adjust sugar to your taste. See salad section for Taco Salad recipe to pair with this dressing!',
    relatedIds: ['taco-salad']
  },

  // ============ NEW RECIPES (from Jill's recipe cards) ============
  {
    id: 'middle-eastern-avocado-soup',
    title: 'Middle Eastern Avocado Soup',
    category: 'soups',
    tags: ['Detox Friendly', 'Green / Love', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1594756202469-9ff9799b2e4e?w=600',
    description: 'A creamy, chilled soup rich in vitamins B and C, potassium, and iron. The ginger offsets the creaminess of the avocado beautifully.',
    ingredients: [
      '3 large avocados, peeled and chopped',
      '500ml (16fl oz) vegetable or chicken stock',
      'Juice of 1/2 lemon',
      '6 spring onions, chopped',
      '3 garlic cloves, peeled',
      '250ml (8fl oz) crème fraîche or natural yogurt',
      '1-2.5cm (1/2-1in) piece fresh root ginger, peeled and grated',
      'Salt and freshly ground pepper',
      'Fresh parsley and avocado slices, to garnish'
    ],
    instructions: [
      'Place the avocado in a blender with the stock and lemon juice and blend until smooth.',
      'Add the spring onions, garlic, crème fraîche (or yogurt) and ginger to taste, then blend again.',
      'Season with salt and pepper.',
      'Cover and chill for 1 hour.',
      'Add more stock if too thick, and lemon juice to taste.',
      'Serve garnished with parsley and avocado slices.'
    ],
    tips: 'This soup is beneficial for the nervous system and can help with stress. Perfect as a summer main dish!'
  },
  {
    id: 'tanzanian-banana-coconut',
    title: 'Tanzanian Banana & Coconut Milk',
    category: 'smoothies',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow'],
    image: 'https://images.unsplash.com/photo-1685967836529-b0e8d6938227?w=600',
    description: 'A wonderfully sweet, grounding smoothie rich in B vitamins, calcium, magnesium, iron, and potassium. Calming and rejuvenating.',
    ingredients: [
      '3 medium-sized, ripe bananas',
      '250ml (8fl oz) coconut milk',
      'Ground cinnamon, to serve (optional)'
    ],
    instructions: [
      'Place the bananas and coconut milk in a blender.',
      'Blend until smooth.',
      'Sprinkle cinnamon on top when serving, if liked.'
    ],
    tips: 'Bananas and coconut are strengthening and rejuvenating. Their grounding and calming effect make them ideal foods for relieving stress.'
  },
  {
    id: 'nettle-cabbage-soup',
    title: 'Nettle & Cabbage Soup',
    category: 'soups',
    tags: ['Detox Friendly', 'Green / Love', 'Orange / Flow'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/8gm1skuu___opt__aboutcom__coeus__resources__content_migration__simply_recipes__uploads__2014__03__nettle-soup-horiz-a-1600-0931ab959b9b4b019274c605f9990b9d.jpg',
    description: 'A vibrant green soup bursting with vitamins and minerals. Nettles cleanse and restore vitality, while cabbage purifies the blood.',
    ingredients: [
      '1 tablespoon olive oil',
      '1 large onion, peeled and chopped',
      '2 leeks, washed and sliced',
      '100g (4oz) cabbage, chopped',
      '1.2 litres (2 pints) vegetable or chicken stock',
      'Salt and freshly ground pepper',
      '2 handfuls nettle tops, washed',
      '2 tablespoons chopped fresh parsley or coriander',
      'Ground nutmeg and boiled egg slices to garnish'
    ],
    instructions: [
      'Heat the oil in a saucepan.',
      'Add the onion and cook until soft.',
      'Add the leeks and cabbage, cover, and cook on a low heat for 10 minutes.',
      'Add the stock and seasoning.',
      'Bring to the boil and simmer for 20 minutes.',
      'Add the nettles for the last few minutes.',
      'Remove from the heat and blend.',
      'Add the parsley or coriander before serving.',
      'Garnish with nutmeg and slices of boiled egg.'
    ],
    tips: 'The abundant chlorophyll in nettles gives this soup a wonderfully vibrant colour. Nettles stimulate the liver and kidneys, cleansing the body of toxins.'
  },
  {
    id: 'tuscan-spring-tonic',
    title: 'Tuscan Spring Tonic',
    category: 'teas',
    tags: ['Detox Friendly', 'Orange / Flow', 'Green / Love', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1556764900-78b59cf886af?w=600',
    description: 'A thick, highly nutritious vegetable juice perfect as a Spring cleanser. Celery, parsley, and carrots aid toxin elimination.',
    ingredients: [
      '250ml (8fl oz) carrot juice',
      '125ml (4fl oz) celery juice',
      '1 garlic clove',
      '1 handful of fresh parsley',
      'Sprigs of parsley, to garnish'
    ],
    instructions: [
      'Blend all the ingredients together in a liquidizer or food processor.',
      'Serve with a garnish of parsley.'
    ],
    tips: 'Garlic invigorates the whole body, disinfecting and cleansing as it goes. All ingredients have diuretic properties to help eliminate toxins via the kidneys.'
  },
  {
    id: 'blueberry-spinach-smoothie',
    title: 'Blueberry Spinach Smoothie',
    category: 'smoothies',
    tags: ['Detox Friendly', 'Blue / Truth', 'Green / Love'],
    image: 'https://images.unsplash.com/photo-1575159249868-df58bf5e09ec?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'This Blueberry Spinach Smoothie is packed with antioxidants and fiber and low in calories. It\u2019s an easy smoothie recipe and the perfect way to get more of your daily greens.',
    servings: '2 servings',
    time: '5 minutes',
    ingredients: [
      '1 cup unsweetened almond milk',
      '1 cup chopped spinach, packed',
      '1 frozen banana, sliced',
      '1 1/2 cups blueberries, fresh or frozen',
      '1 tablespoon honey',
      '1 teaspoon grated fresh ginger'
    ],
    instructions: [
      'Add the almond milk and spinach to a blender and blend until smooth.',
      'Add the frozen banana, blueberries, honey, and grated ginger.',
      'Blend on high until creamy and smooth. Add a splash more almond milk to thin, if needed.',
      'Pour into glasses and enjoy right away.'
    ],
    tips: 'Use frozen banana and blueberries for a thick, frosty texture. Spinach keeps it mild and green-goodness-rich without overpowering the berries.'
  },

  {
    id: 'cucumber-dill-radish-salad',
    title: 'Cucumber, Dill & Radish Summer Salad',
    category: 'salads',
    tags: ['Detox Friendly', 'Green / Love', 'Blue / Truth'],
    image: 'https://static.prod-images.emergentagent.com/jobs/ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/images/6b2deea9749da1a41e00ca4f4baca2ae4c7dab3f4b15817fd1a9743a66404a6b.png',
    description: 'A crisp, refreshing summer salad — cool cucumber, peppery radish, and plenty of fresh dill in a bright lime dressing. Lovely for The Love, and easy to make dairy-free.',
    servings: '2–3 servings',
    time: 'Prep 10 min · Marinate up to 1 hr',
    ingredients: [
      '3–4 small cucumbers (roughly 2 cups)',
      '4–5 radishes, or more to taste',
      '1/4 cup fresh dill',
      'Chives, for garnish',
      'Red onion, optional for extra zip',
      '— Dressing —',
      '1 lime (1 part)',
      '2 parts olive oil',
      '1 tbsp yogurt, optional (for a creamy dressing)',
      '1 tsp honey, or to taste',
      'Salt and pepper, to taste',
    ],
    instructions: [
      'Chop or mandolin the cucumbers and radishes.',
      'Mix all the dressing ingredients together. For a creamy dairy-free version, use coconut yogurt or coconut milk in place of the yogurt — or leave it out for a clear dressing.',
      'Toss the cucumbers and radishes with the dressing. Add red onion for extra zip if you like.',
      'Allow to marinate in the fridge for up to one hour.',
      'Garnish with chives and enjoy.',
    ],
    tips: 'The marinating time softens the radish bite and lets the flavours meld — but it\'s lovely fresh too. Coconut yogurt keeps it detox and dairy-free while still creamy.'
  },
  {
    id: 'fruit-vegetable-salad',
    title: 'Detox Salad',
    category: 'salads',
    tags: ['Detox Friendly', 'Rainbow / All Systems'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/wuoc1qaa_346475943_770814561211894_8845456416897953785_n.jpg',
    description: 'A colorful, make-ahead salad with grilled halloumi. The base keeps for days - just add fresh ingredients daily! Perfect for meal prep.',
    ingredients: [
      '--- BASE SALAD (make ahead) ---',
      'Roughly 1/2 - 1 cup each chopped:',
      'Beets (cooked)',
      'Celery',
      'Carrot',
      'Red cabbage',
      'Broccolini stalks',
      'Parsley',
      'Red/yellow pepper (when not on detox)',
      '--- ADD FRESH DAILY ---',
      'Chopped apple',
      'Cucumber',
      'Avocado',
      'Green onion',
      'Cubed grilled halloumi cheese',
      'Toasted pine nuts, pecans or walnuts',
      'Pumpkin seeds',
      '--- DRESSING ---',
      '1 part lemon juice',
      '1 part apple cider vinegar or coconut vinegar',
      '2 parts olive oil',
      'Fine chopped basil to taste',
      'Dry mustard to taste',
      'Honey to taste',
      'Pink salt or similar',
      'Fresh cracked pepper'
    ],
    instructions: [
      'Chop all ingredients for base salad into a large bowl.',
      'If keeping for several days, place in air tight container (preferably non-plastic), moisten a paper towel and place over top - will keep everything fresher longer.',
      'Slice and pan fry halloumi cheese in butter, cool and chop. This can also be placed in fridge for a few days, but tastiest fresh :)',
      'Add fresh daily the more gentle ingredients that will spoil if cut ahead.',
      'Add dressing and enjoy - can make ahead for ease, but best to make same day, as the lemon will retain its enzymes.'
    ],
    tips: 'Cucumber and apple and cheese aren\'t technically detox friendly, but a little goes a very long way in this salad to add interest and contrast for your taste buds. Feel free to opt out of these ingredients. I would put this entire salad in the 90/10 basket :)'
  },
  {
    id: 'taco-salad',
    title: 'Taco Salad',
    category: 'salads',
    tags: ['Family Favorite', 'Rainbow / All Systems'],
    image: 'https://customer-assets.emergentagent.com/job_700388ba-a714-4c23-a033-dff2d75d65ef/artifacts/bdbnlrkd_IMG_4479.jpeg',
    description: 'One of my all-time favorite go-to recipes — delicious, nutritious, and beautifully colorful. So much of our satisfaction comes first from the eyes, and this salad delivers. It\'s a childhood family favorite that I\'ve grown up alongside and made a little healthier (because that\'s what I do as an adult — I make things healthier). Pair with my Cloned Catalina Dressing for the full nostalgic-but-better experience.',
    ingredients: [
      '--- SALAD BASE (pick your favorite or mix) ---',
      'Romaine lettuce, chopped (or any lettuce that appeals to you)',
      'OR shredded cabbage (great low-oxalate option)',
      '--- TOPPINGS (use any combo, and add your own!) ---',
      'Grated carrot',
      'Tomatoes (cherry or chopped)',
      'Cucumber',
      'Black beans',
      'Ground turkey, seasoned (see below)',
      'Grated white cheddar cheese',
      'Crushed corn chips',
      'Corn',
      'Onion',
      'Avocado',
      'Peppers',
      '--- SEASONED GROUND TURKEY ---',
      '1 lb dark meat ground turkey',
      '1 – 1½ tsp (or to taste) of EACH of the following:',
      'High-quality salt',
      'Pepper',
      'Chili powder',
      'Paprika',
      'Turmeric (if you want extra healing)',
      'Cumin',
      'Old Bay seasoning',
      '--- DRESSING ---',
      'Cloned Catalina Dressing (see recipe in dressings/sauces)'
    ],
    instructions: [
      'Cook the ground turkey in a skillet over medium heat, breaking it apart as it browns.',
      'Add salt, pepper, chili powder, paprika, turmeric, cumin, and Old Bay — about 1 to 1½ tsp of each (or to taste). Stir to coat and let the spices toast through the meat. Set aside.',
      'Build your salad base in a big bowl with romaine or cabbage (or both).',
      'Layer or section out your toppings — grated carrot, tomatoes, cucumbers, black beans, corn, onion, avocado, peppers, grated white cheddar, and the seasoned ground turkey.',
      'Finish with crushed corn chips on top for crunch.',
      'Drizzle generously with Cloned Catalina Dressing and toss right before eating.'
    ],
    tips: 'If you\'re on a low-oxalate diet, opt out of the lettuces, beans, and legumes — cabbage works beautifully as the base. This salad is endlessly customizable: think of it as a build-your-own taco bowl. The key is color and contrast — the more vibrant your plate, the more satisfying the meal.',
    relatedIds: ['cloned-catalina-dressing']
  },
  {
    id: 'gut-glow-crunch-salad',
    title: 'Gut & Glow Crunch Salad',
    category: 'salads',
    tags: ['Green / Love', 'Gluten Free'],
    image: 'https://customer-assets.emergentagent.com/job_1e935ed4-0433-457e-9559-d73f82154bb5/artifacts/5u2azfqk_Healthy-Green-Cabbage-Salad-recipe-vegan-gluten-free-paleo-low-carb-keto-Whole30-466x700.jpg',
    description: 'A healthy salad that actually tastes incredible — leaves you feeling refreshed, lighter, and satisfied. Thinly shredded gut-friendly cabbage, hydrating cucumber, a generous handful of fresh herbs, and a creamy sesame-ginger dressing that is honestly addictive. The Love loves this one.',
    ingredients: [
      '--- SALAD ---',
      '1/2 green cabbage, thinly shredded',
      '3–4 oz arugula',
      '1/2 English cucumber, thinly sliced',
      '3–4 scallions, sliced',
      'Handful of cilantro, chopped',
      'Handful of fresh mint, chopped',
      'Sesame seeds (optional, for crunch)',
      'Peanuts (optional, for crunch)',
      '--- SESAME-GINGER DRESSING ---',
      '1 to 1½ inch chunk fresh ginger',
      '3 cloves garlic',
      '4–5 tbsp tahini',
      '5 tbsp rice vinegar',
      '1 tbsp sesame oil',
      '1 tbsp gluten-free soy sauce, tamari, or coconut aminos',
      'Salt & pepper, to taste',
      '--- OPTIONAL PROTEIN ---',
      'Grilled chicken, steak, shrimp, salmon, tofu, or edamame',
    ],
    instructions: [
      'Thinly shred the cabbage and add to a large bowl along with the arugula, cucumber, scallions, cilantro, mint, sesame seeds, and chopped peanuts. The key is to shred the cabbage really thinly — a mandolin makes quick work of it — and to finely dice the rest of the ingredients so you get a little of everything in every bite.',
      'Add the ginger, garlic, tahini, rice vinegar, sesame oil, soy sauce (or tamari/coconut aminos), salt, and pepper to a blender or food processor. Blend until smooth and creamy.',
      'Pour the dressing over the salad and toss really well until everything is coated.',
      'Let it sit for 5–10 minutes so the cabbage softens slightly and soaks up all the flavour.',
      'Top with your favourite protein — grilled chicken, steak, shrimp, salmon, tofu, or edamame — and enjoy.',
    ],
    tips: 'Cabbage is one of the best gut-friendly foods you can eat — fibre-rich, slightly fermented when it sits in the dressing, and full of compounds that support your microbiome. The fresh herbs (mint + cilantro) are gentle natural detoxifiers and add brightness that makes this salad feel alive. Make a double batch of the dressing and keep it in the fridge for the week — it\'s incredible drizzled on roasted veggies, grain bowls, or used as a dip.\n\nInspired by @shredhappens.'
  },
  {
    id: 'napa-cabbage-salad',
    title: 'Napa Cabbage Salad with Asian Dressing',
    category: 'salads',
    tags: ['Green / Love', 'Gluten Free'],
    image: 'https://images.unsplash.com/photo-1739660740388-542d7c521dc7?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'Napa Cabbage Salad is crisp, crunchy and utterly addictive! This vegan salad is sweet, savory and tossed in an Asian dressing!',
    servings: '8 servings',
    time: '15 min prep + 10 min cook',
    ingredients: [
      '--- SALAD ---',
      '1 head napa cabbage (small to medium), halved and sliced thinly',
      '2 medium navel oranges',
      '1 medium carrot, cut into matchsticks or grated',
      '1 red bell pepper, sliced thinly and cut into bite-sized pieces',
      '2 green onions, sliced thinly on the bias',
      '½ cup cilantro, chopped',
      '½ cup sliced almonds',
      '--- ASIAN DRESSING ---',
      '4 tbsp rice wine vinegar',
      '3 tbsp olive oil (or other non-inflammatory oil)',
      '2 tbsp fresh orange juice (squeezed from the remaining orange after segmenting)',
      '1 tbsp sesame oil',
      '1½ tbsp gluten-free soy sauce, tamari or coconut aminos',
      '1 tbsp maple syrup or honey',
      '¼ tsp sea salt (or to taste)',
      '1–2 tbsp nut butter of choice or tahini (optional)',
      '⅛ tsp freshly ground black pepper (or to taste)',
    ],
    instructions: [
      'Place an orange on a cutting board and cut off the top and bottom. Stand it up and remove the peel from the sides by cutting top to bottom all the way around, removing the white pith.',
      'Cut along one side of each orange segment, then along the other side at a slight angle to release it. Set the orange segments aside for the salad.',
      'Squeeze the remaining orange after segmenting and reserve the juice for the dressing (about 2 tablespoons).',
      'Preheat the oven to 350°F. Place the almonds on a rimmed baking sheet and bake for 7–10 minutes, until golden brown and fragrant.',
      'Whisk together the rice wine vinegar, oil, reserved orange juice, sesame oil, soy sauce, maple syrup, salt and pepper (and nut butter or tahini, if using) until combined.',
      'Place the napa cabbage, orange segments, carrot, bell pepper, green onions and cilantro in a large bowl.',
      'Toss with enough dressing to coat and top with the toasted almonds. Serve.',
    ],
    tips: 'Add 1–2 tbsp of nut butter or tahini to the dressing for a creamier, more filling version.'
  },

  {
    id: 'thai-salad',
    title: 'Thai Salad',
    category: 'salads',
    tags: ['Green / Love', 'Gluten Free'],
    image: 'https://images.unsplash.com/photo-1530912585210-7916cd026e59?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'This fresh & simple Thai Salad is a perfect combination of fresh and healthy ingredients. Easy, quick and delicious!',
    servings: '2 servings',
    time: '20 minutes',
    ingredients: [
      '--- SALAD ---',
      '3 cups mixed salad greens',
      '1 Lebanese cucumber, julienned',
      '¼ red onion, very finely sliced',
      '1 red pepper, finely sliced',
      '1 carrot, julienned',
      '¼ cup cilantro, roughly chopped',
      '1 tbsp peanuts, roughly chopped (optional)',
      '--- DRESSING ---',
      '½ red chilli, seeds removed, finely diced',
      '2 tbsp coconut aminos (or gluten-free soy sauce or tamari)',
      '2 tsp sugar or honey',
      '1 tsp fish sauce',
      '1 tsp sesame oil',
      '1 tbsp lime juice',
      '--- OPTIONAL ---',
      'Rice noodles or bean threads, to add',
    ],
    instructions: [
      'Make the dressing by placing all dressing ingredients in a jar and shaking. Adjust flavours according to taste.',
      'Slice the onion, cucumber, carrot and red pepper very finely — julienne the carrot and cucumber.',
      'Place the salad leaves in a large bowl.',
      'Top with the onion, cucumber, carrot and red pepper.',
      'Pour the dressing over the salad and lightly toss.',
      'Top with mint, coriander, and peanuts (if using).',
    ],
    tips: 'Add rice noodles or bean threads to make it a more filling meal.'
  },

  {
    id: 'mango-black-bean-salad',
    title: 'Mango Black Bean Salad',
    category: 'salads',
    tags: ['Detox Friendly', 'Orange / Flow', 'Red / Root', 'Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_1e935ed4-0433-457e-9559-d73f82154bb5/artifacts/kt6hvhfc_OSK.jpg',
    description: 'A bright, juicy summer salad of sweet mango, black beans, grilled corn, and crisp jicama tossed in a zesty lime vinaigrette and finished with creamy avocado. Refreshing, colorful, and endlessly easy to make your own.',
    servings: '4–6 servings',
    ingredients: [
      '2 ripe but firm mangoes, diced',
      '15 ounce can black beans, rinsed',
      '1 ear corn, grilled',
      '1 1/2 cups jicama, diced',
      '1/4 cup chopped cilantro',
      'Zest of one lime',
      '2 tablespoons fresh lime juice (about 1 lime)',
      '3 tablespoons olive oil',
      '2 avocados, sliced',
      'Sea salt + pepper, to taste'
    ],
    instructions: [
      'Grill the ear of corn, slice corn off ear, and set aside to cool.',
      'Peel and dice the mango and jicama. Rinse the black beans and add beans, jicama, mango, and corn in bowl. Season with salt and pepper.',
      'Combine lime zest, juice, olive oil, and salt and pepper in a mason jar. Shake well to combine. Drizzle over the salad and gently toss with the chopped cilantro.',
      'Top with sliced avocado.',
      'Serve immediately or refrigerate overnight (without the avocado) and serve at room temperature. Top with avocado when ready to serve.'
    ],
    tips: 'You can sub the protein for the black beans — try grilled chicken, shrimp, or salmon to make it a heartier main. Inspired by parsnipsandpastries.com.'
  },
  {
    id: 'beet-salad-roasted-fennel-blood-orange',
    title: 'Beet Salad with Roasted Fennel, Blood Orange & Citrus Vinaigrette',
    category: 'salads',
    tags: ['Red / Root', 'Orange / Flow'],
    image: 'https://images.pexels.com/photos/5272100/pexels-photo-5272100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'This beet salad includes roasted fennel, blood oranges, caramelized walnuts, and a citrus tahini vinaigrette. It is colorful, sweet, and savory — grounding for The Root and bright for The Flow.',
    servings: '6–8 servings',
    time: 'Prep 10 min · Cook 45 min · Total 55 min',
    ingredients: [
      '--- FOR THE SALAD ---',
      '4 beets (golden and/or red), roasted, peeled, and sliced',
      '1 large fennel bulb, roasted and sliced, fronds reserved',
      'Olive oil, salt, and pepper',
      '3 blood oranges, supremed',
      '10 ounces mixed baby greens',
      'Caramelized walnuts or pecans (recipe below)',
      'Citrus vinaigrette (recipe below)',
      'Chopped fennel fronds, for garnish',
      'Optional: add any protein of choice (steak, chicken, chickpeas, black beans)',
      '--- FOR THE CITRUS VINAIGRETTE ---',
      '1/2 cup extra-virgin olive oil',
      '3 tablespoons lemon/lime/orange juice, combo of your choice',
      '1 teaspoon dry mustard',
      '1 teaspoon honey, or to taste',
      '3 tablespoons tahini',
      'Salt and pepper, to taste',
      'Optional: add cayenne or other enticing spice',
      '--- FOR THE CANDIED WALNUTS ---',
      '1 cup walnuts',
      '1 tablespoon date syrup',
      'Pinch of salt, pepper, and spice of choice (optional)'
    ],
    instructions: [
      'Roast the beets and fennel. Preheat the oven to 400°F and rub the beets with olive oil and salt. Wrap the beets in foil and roast until tender, about 45 minutes. Cool, peel the beets, and slice.',
      'Trim and core the fennel (reserving the fronds) and halve. Drizzle with olive oil, salt, and pepper and roast for the last 30 minutes the beets are cooking, until tender and caramelized. Slice the fennel into thin slices.',
      'Make the candied walnuts. Heat the nuts in an even layer in a skillet for 1–2 minutes, add the date syrup, and caramelize until a deep golden brown. Pour onto a parchment-lined tray immediately. Sprinkle with salt, pepper, and a little spice if you wish, and let cool completely. Once cool, chop the walnuts.',
      'Make the vinaigrette. Combine the olive oil, citrus juice, tahini, honey, salt, and pepper in a shaker. Shake until emulsified.',
      'Assemble the salad. Arrange the sliced beets, fennel, and blood oranges on top of the mixed greens. Drizzle with the vinaigrette and top with the caramelized walnuts and fennel fronds.'
    ],
    tips: 'Beets are a true Root food — grounding and mineral-rich — while the bright citrus and fennel feed The Flow. Add a protein (steak, chicken, chickpeas, or black beans) to make it a full meal. The candied walnuts and vinaigrette can both be made ahead.'
  },
  {
    id: 'purple-slaw',
    title: 'Purple Slaw',
    category: 'salads',
    tags: ['Detox Friendly', 'Red / Root', 'Violet / Spirit'],
    image: 'https://customer-assets.emergentagent.com/job_1e935ed4-0433-457e-9559-d73f82154bb5/artifacts/m5bw8mpa_purple-cabbage-slaw-1.jpg',
    description: "I love this simple, easy coleslaw that keeps well in the fridge for several days. For me, this and a protein and I'm good. Feel free to add other yumminess. This is a recipe my mum made often when I was growing up — I'm glad I can eat cabbage again!",
    servings: '4–6 servings',
    ingredients: [
      '1/2 head of red cabbage',
      '1/2 cup white or apple cider vinegar',
      '1 teaspoon celery seed',
      '1/2 teaspoon cracked pepper, and salt to taste',
      '3/4 cup extra-virgin olive oil',
      '1/4 cup (or more) brown sugar or honey'
    ],
    instructions: [
      'Finely mandolin the cabbage into long thin strips — the thinner the better, trust me.',
      'Over medium heat, add the vinegar to a small saucepan along with the celery seed, salt, and pepper. If using brown sugar, add it now.',
      'Remove from the heat once everything is incorporated and a bit of steam is forming.',
      'Add the honey once off the heat, mix well, then add the olive oil.',
      'Pour while still hot over the cabbage and mix well.',
      'Eat immediately — delicious, and even better if it has time to marinate.',
      'Gets better with age; will last 3–5 days in the fridge.'
    ],
    tips: 'Red cabbage is rich, grounding, and beautifully purple — feeding both The Root and The Spirit. Pair with any protein for an easy, make-ahead meal.'
  },
  {
    id: 'grilled-lemon-chickpea-salad',
    title: 'Grilled Lemon Chickpea Salad with Pickled Shallots',
    category: 'salads',
    tags: ['Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_1e935ed4-0433-457e-9559-d73f82154bb5/artifacts/d6rq811c_OIP.webp',
    description: 'A bright, Mediterranean-inspired chickpea salad layered with quick-pickled shallots, charred grilled lemon vinaigrette, juicy heirloom tomatoes, cucumbers, feta, and olives. The grilled lemon adds a smoky depth that wakes up the whole bowl — and it only gets better as it marinates. A beautiful one to feed The Fire.',
    servings: '4–6 servings',
    time: '30 minutes (plus 1 hour to pickle)',
    ingredients: [
      '--- QUICK-PICKLED SHALLOTS ---',
      '2 shallots, thinly sliced',
      '2 ounces rice vinegar',
      '2 tablespoons sugar',
      '1 ounce red wine',
      'Heavy pinch of salt',
      '--- GRILLED LEMON VINAIGRETTE ---',
      '1/2 cup olive oil',
      '1/4 cup grilled lemon juice',
      '1 tablespoon Dijon mustard',
      '1 teaspoon honey',
      '1 teaspoon dried oregano',
      'Sea salt and pepper, to taste',
      '--- SALAD ---',
      '3–4 lemons, for the vinaigrette and for serving',
      '2 cans chickpeas, rinsed and drained',
      '3 Persian cucumbers, diced (2 cups)',
      '1 pound mini heirloom tomatoes, halved',
      '1/2 cup crumbled feta',
      '1/2 cup Kalamata olives, pitted and halved',
      '1/2 cup roasted red peppers, diced',
      '1/4 cup fresh parsley, chopped',
    ],
    instructions: [
      'Pickled shallots — Combine the vinegar, sugar, salt, and red wine in a small saucepan and bring to a simmer. Add in the thinly sliced shallots and simmer one minute. Remove from heat.',
      'Let the mixture cool to room temperature and sit for about an hour. Strain the shallots.',
      'Grilled lemon vinaigrette — Cut the lemons in half cross-wise and brush the cut sides with olive oil and a sprinkle of salt. Grill the lemons over medium-high heat until heated through and charred, about 3 minutes.',
      'Squeeze the lemons (discarding the seeds) to measure a 1/4 cup of lemon juice. This should be about 2 or so lemons. Keep the additional grilled lemons for garnish.',
      'In a mason jar, combine the lemon juice with the olive oil, Dijon mustard, honey, oregano, and sea salt and pepper to taste. Shake well until combined.',
      'Assemble the salad — Combine the rinsed and drained chickpeas with the drained pickled shallots, cucumbers, tomatoes, feta, olives, roasted red peppers, and parsley.',
      'Pour over the vinaigrette and toss everything until combined.',
      'Serve the salad with the additional grilled lemon as garnish. Serve immediately or chill in the fridge and allow to marinade overnight to deepen and balance the flavors.',
    ],
    tips: 'Grilling the lemons before juicing them mellows their sharpness and adds a subtle smoky-sweet depth — don\'t skip it. This salad is a make-ahead dream: it actually tastes better the next day once everything has had time to marinate. Leave out the feta to keep it dairy-free.\n\nInspired by Parsnips + Pastries.'
  },
  {
    id: 'whole30-chia-pudding',
    title: 'Easy Whole30 Chia Pudding with Bananas and Macadamia Nuts',
    category: 'breakfast',
    categories: ['breakfast', 'snacks'],
    tags: ['Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_48b77d27-521b-4770-89b0-c52759bc01d9/artifacts/7o8vnww1_IMG_4716.jpeg',
    description: 'A creamy, make-ahead chia pudding sweetened naturally with banana and topped with toasted macadamia nuts and a sprinkle of cinnamon. Whole30-compliant, dairy-free, and ready with just 10 minutes of prep — a gentle, nourishing way to start the day and feed The Fire.',
    servings: '2 servings',
    time: '10 minutes (plus overnight to set)',
    ingredients: [
      '1/4 cup organic chia seeds',
      '1 cup compliant unsweetened light coconut milk or almond milk, plus more for thinning*',
      '1 vanilla bean pod',
      'Pinch of sea salt',
      '1/2 teaspoon cinnamon or compliant pumpkin spice',
      '1 banana, sliced',
      '1/4 cup toasted macadamia nuts, chopped',
    ],
    instructions: [
      'Combine the chia seeds with the compliant non-dairy milk and whisk well to combine. Split the vanilla bean down the center and scrape out the seeds into the chia mixture. Add in the sea salt and cinnamon.',
      'Refrigerate the chia pudding overnight.',
      'When ready to eat, stir the pudding to combine well and divide it between two bowls. Top each bowl with banana, macadamia nuts, and a sprinkle of cinnamon. Enjoy!',
    ],
    tips: '*If you would like your chia pudding a thinner consistency once it sets overnight, simply whisk or stir in some additional milk before serving.\n\nRecipe credit: Whole30 (via Parsnips + Pastries).'
  },
  {
    id: 'stewed-apples',
    title: 'Stewed Apples',
    category: 'breakfast',
    categories: ['breakfast', 'snacks'],
    tags: ['Red / Root'],
    image: 'https://images.pexels.com/photos/7839801/pexels-photo-7839801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'Warm, cinnamon-spiced stewed apples — soft, comforting, and naturally sweet. Wonderful warm or cold, on their own or with a dollop of yoghurt. Cinnamon helps balance blood sugar, and a sprinkle of probiotic powder after cooking makes this a gut-loving way to start the day or settle a craving. Grounding and nourishing for The Root.',
    servings: '2 servings',
    time: '15 minutes',
    ingredients: [
      '4 apples (preferably organic cooking apples)',
      '1/3 cup water (preferably filtered)',
      '2 tsp cinnamon',
      '1/2 cup raisins or sultanas (if required for sweetness — also provides fibre)',
      '8 to 10 almonds (for protein)',
      '1 knob butter (optional)',
    ],
    instructions: [
      'Peel the apples if desired. The peel contains fibre, minerals, and other nutrients, so it\'s best nutritionally not to peel.',
      'Core the apples and chop them into small, evenly sized pieces.',
      'Add the water and butter to the sauce pan and heat until the butter has just melted.',
      'Add the remaining ingredients to the pan, cover, and cook on a low heat for about 10–15 minutes, stirring regularly. Add more water if the pan becomes dry and the apples risk burning. Cook until soft with rough shapes, no longer identifiable as apple slices. The colour should be a russet brown with the cinnamon effect.',
      'Add any extra probiotic powders once the apples have been taken off the heat (so as not to damage the probiotics).',
      'Eat warm or cold. Delicious with yoghurt and cinnamon.',
    ],
    tips: 'Stewed apples can be eaten as a snack, dessert, or a meal substitute (no more than one substitution per day), and can be cooked in the evening and stored in the fridge to be eaten the next day. Cinnamon is anti-inflammatory and helps balance the blood sugar spike seen after eating apples. A capsule of a probiotic such as Lactobacillus GG, Saccharomyces Boulardii, or Bifidobacteria can be opened and sprinkled on top of the cooked apples before serving to add beneficial probiotic bacteria.\n\nRecipe credit: Fairfield Nutrition.'
  },
  {
    id: 'berry-yogurt-bowl',
    title: 'Berry & Yogurt Bowl with Nuts & Seeds',
    category: 'breakfast',
    categories: ['breakfast', 'snacks'],
    tags: ['Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_48b77d27-521b-4770-89b0-c52759bc01d9/artifacts/o3ps2qwd_IMG_4783.jpeg',
    description: 'Gently simmered berries spooned over creamy full-fat Greek yogurt, finished with crunchy nuts and seeds and a drizzle of honey or cinnamon. Filling, yummy, and beautifully balanced — easily digestible fruit, gut-loving probiotics, and protein and fat to buffer and nourish. Delish as breakfast or as a snack.',
    servings: '1 serving',
    time: '10 minutes',
    ingredients: [
      '2 handfuls berries (frozen is great and convenient)',
      '1/2 cup full-fat plain Greek yogurt',
      '2 tbsp chopped mixed nuts (or nuts of choice)',
      '1 tbsp sunflower and/or pumpkin seeds',
      'Honey and/or cinnamon, to taste',
      'Nut butter of choice, optional (avoid peanut butter)',
    ],
    instructions: [
      'Gently cook the berries over low heat until some juice has released.',
      'Spoon the warm simmered fruit over top of the yogurt.',
      'Sprinkle over the nuts and seeds.',
      'Add honey and/or cinnamon to taste. For extra yum and protein, add a nut butter of choice (avoid peanut butter, please).',
    ],
    tips: 'The fruit will be easily digestible and nourishing for our digestion. The yogurt gives us some probiotics — feel free to use a non-dairy yogurt, but be mindful of ingredients, as there\'s a lot of garbage like gums, citric acid, other preservatives, and added sugars. The nuts and seeds give us some protein and fat to buffer and nourish.'
  },
  {
    id: 'mixed-berries',
    title: 'Mixed Berries',
    category: 'breakfast',
    categories: ['breakfast', 'snacks'],
    tags: ['Red / Root'],
    image: 'https://images.pexels.com/photos/7368026/pexels-photo-7368026.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'Simple, beautiful, and grounding — a bowl of fresh or frozen mixed berries. Strawberries, blueberries, raspberries, and blackberries are low in sugar, high in fibre, and loaded with antioxidants. Enjoy them on their own, stirred into yogurt, blended into a smoothie, or gently warmed. A naturally sweet way to nourish The Root.',
    servings: '1 serving',
    time: '2 minutes',
    ingredients: [
      'A handful or two of mixed berries — strawberries, blueberries, raspberries, blackberries',
      'Fresh, or frozen and thawed (or gently warmed)',
      'Optional: a sprinkle of cinnamon',
      'Optional: a dollop of full-fat Greek or non-dairy yogurt',
    ],
    instructions: [
      'Rinse fresh berries (or thaw frozen ones — gently warming frozen berries over low heat until they release their juices is lovely too).',
      'Add to a bowl on their own, or spoon over yogurt.',
      'Finish with a sprinkle of cinnamon if you like, and enjoy.',
    ],
    tips: 'Berries are one of the lowest-sugar fruits and are packed with fibre and antioxidants that support the whole body. Frozen berries are just as nutritious as fresh — keep a bag in the freezer for an easy breakfast or snack. Delicious paired with nuts, seeds, or a spoonful of yogurt for added protein and staying power.'
  },
  {
    id: 'egg-power-bowl',
    title: 'Egg Power Bowl',
    category: 'breakfast',
    categories: ['breakfast', 'snacks'],
    tags: ['Rainbow / All Systems'],
    image: 'https://static.prod-images.emergentagent.com/jobs/ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/images/a13431768812eadeeb72bd4f02e9bf19c378d52d13a80e9c09edd38dea681fe3.png',
    description: 'A simple, protein-rich power bowl built on greens, with eggs, avocado, and a sprinkle of fresh flax. Takes minutes, travels well, and tastes good warm or cold — perfect to take on the go and eat at work.',
    servings: '1 serving',
    time: '10 minutes',
    ingredients: [
      '1–2 handfuls of greens of your choice (spinach sautéed, or fresh arugula is nice)',
      'Grated carrot — raw or sautéed (sautéed tastes lovely), or leftover root veg',
      '1–2 eggs, soft cooked or soft boiled for a runny yolk (or cooked to your liking)',
      '1 tbsp fresh ground flax (try to grind your own — pre-ground can go rancid quickly)',
      '1/4–1/2 avocado',
      'Tahini dressing, optional (pairs nicely, but it\'s just as yummy with no dressing)',
    ],
    instructions: [
      'Build a bed of greens — fresh arugula, or sauté spinach if you prefer it warm.',
      'Top with grated carrot (raw or sautéed) or any leftover root veg.',
      'Add your eggs, soft cooked or boiled for a runny yolk (or however you like them).',
      'Slice over the avocado and sprinkle with the fresh ground flax.',
      'Drizzle with tahini dressing if you like, or leave it plain — and enjoy warm or cold.',
    ],
    tips: 'A great take-on-the-go meal — it keeps well and tastes good warm or cold, so it\'s perfect to eat at work. Grind your own flax if you can; pre-ground flax loses freshness and can go rancid quickly.'
  },
  {
    id: 'egg-muffin-cups',
    title: 'Egg Muffin Cups',
    category: 'breakfast',
    categories: ['breakfast', 'snacks'],
    tags: ['Rainbow / All Systems'],
    image: 'https://static.prod-images.emergentagent.com/jobs/ad2f199d-ae4e-4b25-a141-1d6a71ffdd3e/images/78667f7fb44fc720995381c9b71b3b9e8b6ffee27a93af4ffc8b5e0da52ad96b.png',
    description: 'Endlessly flexible baked egg cups — throw in any veg you feel like. Make a batch of 12 for easy, protein-rich meals on the go. They keep in the fridge for up to 4 days and freeze beautifully.',
    servings: '12 muffin cups',
    time: 'Prep 15 min · Bake 25–30 min',
    ingredients: [
      '1 1/4 cups chopped spinach',
      '2 cups (or more) of any diced veg — see notes',
      'When detoxing: roasted veg is great — carrots, sweet potato, beets, asparagus, avocado, onion, etc.',
      'When not detoxing: roma tomatoes, diced baby bella mushrooms, green bell pepper',
      '10 eggs',
      '1/8 cup water (makes the eggs fluffier)',
      '1 teaspoon salt',
      '1/2 teaspoon garlic powder (optional, for more zip)',
      '1/2 teaspoon onion powder (optional, for more zip)',
      '1/2 teaspoon paprika',
      '1/2 teaspoon pepper',
      '3/4 cup sharp cheddar, freshly grated (sub goat cheese or buffalo mozzarella during detox)',
    ],
    instructions: [
      'Grease a 12-cup muffin tin generously with butter or oil (avoid cooking sprays).',
      'Sauté the spinach first to remove excess water.',
      'Distribute all the veg evenly into the 12 cups.',
      'In a large bowl, whisk together the eggs, water, salt, pepper, onion powder, garlic powder, and paprika until combined.',
      'Pour the egg mixture evenly into the 12 cups, to cover the veggies.',
      'Sprinkle the tops with the optional cheese.',
      'Bake at 350°F for 25–30 minutes, until the eggs are cooked through.',
      'Allow to cool for several minutes in the pan, then run a butter knife around the edges to loosen before removing.',
    ],
    tips: 'Use whatever veg you feel like! During the Detox, skip tomatoes and mushrooms and fill them with other veg instead. Store leftovers in the fridge for up to 4 days, or freeze them for a quick meal on the go.'
  },

  {
    id: 'tex-mex-breakfast-bowl',
    title: 'Tex Mex Bowl',
    category: 'breakfast',
    tags: ['Red / Root', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1647545401834-39096eb7e4ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'A hearty, protein-packed Tex Mex breakfast bowl with seasoned ground turkey, crispy shredded potatoes, soft cottage-cheese scrambled eggs, and fresh toppings.',
    servings: '4 bowls',
    time: '30 minutes',
    ingredients: [
      '— For the turkey —',
      '1 tablespoon olive oil',
      '1 lb (450 g) lean ground turkey',
      '1 teaspoon chili powder',
      '1 teaspoon ground cumin',
      '1/2 teaspoon garlic powder',
      '1/2 teaspoon kosher salt',
      '1/4 teaspoon black pepper',
      '— For the potatoes —',
      '1 tablespoon olive oil',
      '4 cups (340 g) shredded potatoes (or sub carrots or sweet potato)',
      '1/2 teaspoon kosher salt',
      '1/4 teaspoon smoked paprika',
      '1/4 teaspoon black pepper',
      '— For the eggs & bowls —',
      '8 large eggs',
      '1 cup (225 g) cottage cheese, 2% or 4%',
      '1 tablespoon butter',
      '1/2 cup (55 g) shredded cheddar cheese',
      '1 avocado, sliced',
      '1 cup (150 g) diced tomatoes',
      '1/4 cup chopped chives or green onions',
      '1/2 cup salsa, for serving (preferably homemade — see Charred Corn & Avocado Salsa)'
    ],
    instructions: [
      'Cook the turkey: Heat 1 tablespoon olive oil in a large skillet over medium-high heat. Add the turkey, chili powder, cumin, garlic powder, salt, and pepper. Cook for 7-9 minutes, breaking it into crumbles, until browned and fully cooked to 165°F.',
      'Crisp the potatoes: Move the turkey to a plate. Add the remaining olive oil to the skillet, then add the squeezed-dry potatoes, salt, smoked paprika, and pepper. Press into a thin layer and cook for 4-5 minutes before turning. Cook 4-5 minutes more, until golden and crisp at the edges.',
      'Whisk the eggs: In a medium bowl, whisk the eggs and cottage cheese until combined. Small cottage cheese curds are fine and will soften as the eggs cook.',
      'Scramble gently: Melt the butter in a clean skillet over medium-low heat. Add the egg mixture and cook for 4-6 minutes, folding slowly with a spatula, until just set and still soft.',
      'Assemble the bowls: Divide the potatoes, turkey, and eggs among 4 bowls. Sprinkle with cheddar while the warm ingredients can soften it slightly.',
      'Add fresh toppings: Top each bowl with avocado, diced tomatoes, chives, and salsa. Serve warm, or cool the cooked components before storing for meal prep.'
    ],
    tips: 'Great for meal prep — cool the components before storing. Swap the shredded potatoes for carrots or sweet potato if you like.'
  },






  // ============ NEW MAINS (from Jill's recipe cards) ============
  {
    id: 'chicken-satay-bowl',
    title: 'Chicken Satay Bowl',
    category: 'mains',
    tags: ['Detox Friendly', 'Red / Root', 'Yellow / Fire'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/v7f5p61u_chicken-satay-bowl-8503552-February-18-2020-2-1080x1620.webp',
    description: 'A flavorful Thai-inspired bowl with tender marinated chicken, creamy peanut sauce, cucumber salad, and jasmine rice.',
    servings: '2 servings',
    time: '15 minutes (plus marinating)',
    ingredients: [
      '1.5 lb boneless skinless chicken thighs, cut into bite sized chunks',
      '4 cups cooked jasmine rice (or Coconut Rice)',
      '--- MARINADE ---',
      '1/2 cup canned coconut milk (full fat)',
      'Juice of 1/2 lime',
      '1 tsp each turmeric, curry paste, chili paste',
      '1 tsp salt',
      '--- PEANUT SAUCE ---',
      '1/2 cup creamy peanut butter (can sub tahini)',
      '1/4 cup canned coconut milk',
      '2 Tbsp soy sauce (or aminos)',
      '2 Tbsp brown sugar or honey',
      'Juice of 1 lime',
      '2 tsp chili paste',
      '1 tsp sesame oil',
      '1 garlic clove, minced',
      '1 Tbsp grated ginger',
      'Hot water to thin',
      '--- CUCUMBER SALAD ---',
      '2 small Persian cucumbers',
      '1 cayenne pepper (or other small hot pepper)',
      '1 tsp sesame oil',
      '2 tsp rice wine vinegar or lime juice',
      'Sesame seeds',
      '--- GARNISH ---',
      'Fresh cilantro',
      'Lime wedges'
    ],
    instructions: [
      'Mix the marinade in a container or zip lock bag and add the chicken, tossing to coat. Refrigerate for 1-8 hours.',
      'Whisk the peanut sauce ingredients together and add enough hot water to thin for easy dipping. Taste and adjust.',
      'Slice cucumbers thinly (mandolin works great). Seed the pepper and slice into thin strips. Toss with oil and vinegar and refrigerate.',
      'Thread marinated chicken onto skewers (optional - you can skip skewers and use a wok).',
      'Heat a grill pan over medium high heat until very hot. Wipe with cooking oil and grill skewers about 4 minutes each side until charred and cooked through.',
      'Divide rice into bowls, top with salad and chicken. Garnish with cilantro and lime wedges. Drizzle with peanut sauce and serve extra on the side.'
    ],
    tips: 'If not using skewers, cook the marinated chicken in a wok for equally delicious results!'
  },
  {
    id: 'magic-chili',
    title: 'Magic Chili',
    category: 'soups',
    tags: ['Detox Friendly', 'Rainbow / All Systems'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/8bwjytbg_magicchili2-768x1152-4130388695.jpg',
    description: 'One of my go-to healing foods! Magic because it has NO tomato or spice—which can be inflammatory for some people. Perfect for those who don\'t do well with grains, legumes, or nightshade vegetables.',
    servings: '8-10 servings',
    time: '45 minutes',
    ingredients: [
      '1-2 tbsp solid cooking fat (coconut oil, butter, tallow, or duck fat)',
      '4 cups bone broth (previously made)',
      '2 lbs ground turkey (preferably dark meat) (or any ground meat of choice)',
      '1 cup each rustic chopped: onion, carrots, celery, sweet potato, butternut squash',
      '2 chopped parsnips',
      '1 large beet (grated)',
      '4 cloves garlic, minced',
      '2-3 tbsp fresh oregano and thyme',
      '1-2 tbsp Ceylon cinnamon',
      '10-20 drops oregano oil (optional, adds zip)',
      '1/2 tsp pink salt & fresh cracked pepper',
      'Fresh parsley for garnish'
    ],
    instructions: [
      'Use a heavy large pot on medium-high heat, add solid fat. Sauté onions, carrots, celery until onions are translucent (7-10 mins). Add garlic, cook 3 more minutes.',
      'In a separate pan, brown the meat with some fat, half the seasonings, and half a cup of onion until nearly cooked. Set aside, keep all fat.',
      'To partially cooked vegetables, add all spices, cinnamon, salt, pepper, oregano, thyme (more to taste).',
      'Add parsnips and cook 5 minutes. Add squash and sweet potato, cook 5 more minutes.',
      'Add cooked meat to large pot, add bone broth. Simmer 10-15 minutes until sweet potato is mostly cooked.',
      'Grate in peeled large beet, mix well and simmer 5 more minutes until colour is distributed.',
      'Garnish with fresh parsley. Enjoy immediately or let marry in fridge for 24 hours.'
    ],
    tips: 'This recipe is part of my 21 Day Holistic Detox program! Keeps for several days in Mason jars. For freezing, only fill jar 5/6 full, freeze with no lid to allow expansion, then add lid once frozen. A true healing food!'
  },
  {
    id: 'shawarma-chicken',
    title: 'Shawarma Chicken',
    category: 'mains',
    tags: ['Detox Friendly', 'Red / Root', 'Yellow / Fire'],
    image: 'https://images.unsplash.com/photo-1529006557810-274b9b2fc783?w=600',
    description: 'Tender, aromatic Middle Eastern spiced chicken thighs. Perfect on salads, pita, or roasted potatoes.',
    servings: '4-6 servings',
    time: '45-50 mins (plus marinating)',
    ingredients: [
      '2 lbs boneless chicken thighs (washed)',
      '1 large garlic clove, minced (or 2 small cloves)',
      '1 tbsp ground coriander',
      '1 tbsp ground cumin',
      '1 tbsp ground cardamom',
      '1 tsp ground cayenne pepper (reduce to 1/2 tsp for less spicy)',
      '2 tsp smoked paprika',
      '2 tsp salt',
      'Black pepper to taste',
      '2 tbsp lemon juice',
      '3 tbsp olive oil'
    ],
    instructions: [
      'Combine all ingredients in a bowl. Mix well to coat chicken thoroughly.',
      'Marinate in the fridge for 1 hour minimum, or overnight for best flavor.',
      'Layer thighs in a large loaf pan or baking dish to create many layers.',
      'Bake at 400°F for 40-45 minutes or until chicken is cooked thoroughly.',
      'Tip out of pan and slice.',
      'Serve on top of salad, pita, or roasted potatoes.'
    ],
    tips: 'The longer you marinate, the more flavorful! Overnight is ideal. Leftovers reheat beautifully.'
  },
  {
    id: 'whole-roasted-cauliflower',
    title: 'Whole Roasted Cauliflower',
    category: 'mains',
    tags: ['Detox Friendly', 'Violet / Spirit', 'Green / Love'],
    image: 'https://images.pexels.com/photos/6605777/pexels-photo-6605777.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'A whole head of cauliflower brushed with homemade garlic butter and baked until tender. Enjoy it as a main dish — add salads, a protein, or shawarma chicken for a complete meal. Change up the flavours to suit your mood, or get creative!',
    servings: '6 servings',
    time: 'Prep 15 min · Cook 1 hr · Total 1 hr 15 min',
    equipment: 'Dutch oven (or a baking dish covered with foil)',
    ingredients: [
      '— Base —',
      '1 head cauliflower (about 2 pounds)',
      '¼ cup melted butter',
      '1 clove garlic, minced',
      '1 teaspoon lemon zest',
      '¼ teaspoon salt',
      '¼ teaspoon black pepper',
      '2 tablespoons chopped fresh parsley',
      '2 tablespoons shredded Parmesan cheese',
      '— Tahini Sauce (add) —',
      '¼ cup tahini',
      '1 tablespoon olive oil',
      '¼ cup fresh-squeezed lemon juice',
      '2 cloves garlic, minced',
      '¼ teaspoon kosher salt',
      '1-2 tablespoons cold water, if needed to thin',
      '— Variation · Smoky (with tahini sauce) —',
      '⅓ cup olive oil',
      '1 teaspoon garlic powder',
      '1 teaspoon smoked paprika',
      '½ teaspoon ground cumin',
      '¼ teaspoon kosher salt',
      '— Variation · Middle Eastern (with tahini, chimichurri, or cell food) —',
      '1 cup Greek yoghurt',
      '2 tablespoons olive oil',
      '2 cloves garlic, crushed',
      '2 teaspoons ground cumin',
      '1 teaspoon ground coriander',
      '1 teaspoon ground turmeric',
      '1 teaspoon sweet paprika',
      '½ teaspoon chilli flakes (adjust to taste)',
      '1 teaspoon fine salt',
      'Freshly ground black pepper, to taste',
      '— Variation · Italian —',
      '⅓ cup olive oil',
      '2 large cloves garlic, crushed',
      '¼ cup grated Parmesan cheese, divided',
      '1 teaspoon dried basil',
      '1 teaspoon dried oregano',
      '1 teaspoon dried parsley',
      '½ teaspoon coarse salt (optional)',
      '¼ teaspoon black pepper',
      '— Variation · Curry —',
      '5 tablespoons clarified butter or ghee',
      '1 tablespoon olive oil',
      '1 teaspoon salt',
      '2 teaspoons curry powder',
      '½ teaspoon cayenne pepper',
      '¼ teaspoon garam masala'
    ],
    instructions: [
      'Preheat oven to 400°F.',
      'Trim the leaves from the base of the cauliflower.',
      'Combine the butter, garlic, lemon zest, salt, and pepper. Brush the mixture over the entire cauliflower head. (To switch up the flavour, use one of the variation blends below in place of the garlic butter.)',
      'Place the cauliflower in a large Dutch oven, cover, and bake for 40 minutes, or until tender.',
      'Uncover, sprinkle on the Parmesan cheese, and bake for 10-15 minutes more, until the cheese is browned and crispy. Garnish with parsley, if desired.',
      'For the tahini sauce: whisk together the tahini, olive oil, lemon juice, garlic, and salt, thinning with a little cold water as needed. Drizzle over or serve alongside.'
    ],
    tips: 'For softer cauliflower, add 2 tablespoons of broth or water to the bottom of the pan. No Dutch oven? Bake in a dish covered with foil. Test for doneness with a metal skewer. Mix and match the flavour blends and sauces to suit your mood.'
  },

  {
    id: 'coconut-chicken-rice-bowl',
    title: 'Coconut Chicken Rice Bowl',
    category: 'mains',
    tags: ['Detox Friendly', 'Blue / Truth'],
    image: 'https://images.unsplash.com/photo-1584278859516-41e5af3920ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    description: 'A creamy, fragrant one-pan meal with fluffy purple rice and tender coconut curry chicken.',
    servings: '4 servings',
    time: '1 hr 30 mins (plus marinating)',
    ingredients: [
      '— For the Chicken Marinade —',
      '1½ lbs boneless, skinless chicken thighs',
      '2 tbsp coconut aminos, tamari, or gluten-free soy sauce',
      '1 tbsp fish sauce',
      '1 tbsp fresh ginger, grated',
      '5 cloves garlic, minced',
      'Juice of 1 lime',
      '1 tsp paprika',
      '½ tsp black pepper',
      '1 tbsp brown sugar',
      '— For the Coconut Rice —',
      '1 cup purple rice, rinsed well',
      '1 cup full-fat coconut milk',
      '2 cups water or broth',
      '1 tsp salt',
      '— For the Coconut Curry Sauce —',
      '1 can full-fat coconut milk',
      '2 tbsp red curry paste',
      '1 yellow onion, diced',
      '2 tbsp olive oil',
      '1 tbsp sugar (optional, to balance the curry)',
      '— To Finish —',
      'Toasted coconut flakes',
      'Sliced green onions',
      'Fresh cilantro',
      'Lime wedges'
    ],
    instructions: [
      'Marinate the chicken: In a bowl, whisk together the coconut aminos, fish sauce, ginger, garlic, lime juice, paprika, pepper, and brown sugar. Add the chicken thighs and coat well. Cover and refrigerate for at least 30 minutes (a few hours or overnight gives even more flavor).',
      'Bake the coconut purple rice: Preheat oven to 375°F (190°C). Rinse the purple rice until the water runs mostly clear. In a baking dish with a tight-fitting lid (or cover tightly with foil), combine the purple rice, 2 cups broth or water (optional: sub ½ cup coconut milk for ½ cup of the liquid), and salt.',
      'Cover tightly and bake for 60 minutes, or until the rice is tender and the liquid has been absorbed. Let stand, covered, for 10 minutes before fluffing with a fork. Do not check during cooking — trust the process. (Cooking time can vary slightly depending on the brand of purple rice.)',
      'Cook the chicken: Heat the olive oil in a large skillet over medium-high heat. Remove the chicken from the marinade and cook for about 5 to 6 minutes per side, until golden and cooked through. Transfer to a plate and let rest a few minutes before slicing.',
      'Make the coconut curry sauce: Using the same skillet, add the diced onion and sauté for 4 to 5 minutes until softened. Stir in the red curry paste and cook for 1 minute until fragrant. Pour in the remaining can of coconut milk and stir until smooth. Add the sugar if desired and simmer gently for 5 to 8 minutes until slightly thickened.',
      'Assemble the bowls: Divide the coconut purple rice between bowls. Top with sliced chicken. Spoon over the warm coconut curry sauce. Finish with toasted coconut, sliced green onions, fresh cilantro, and a squeeze of fresh lime.'
    ],
    tips: 'Optional add-ins: steamed broccoli, bok choy, roasted sweet potato, edamame, snap peas, or pickled cucumber.'
  },


  // ============ SNACKS & TREATS ============
  {
    id: 'banana-bread',
    title: 'Banana Bread',
    category: 'gluten-free',
    tags: ['Detox Friendly', 'Red / Root', 'Orange / Flow'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/xddnh195_coconut-flour-banana-bread.jpg',
    description: 'A healthy, grain-free banana bread made with coconut flour and nut butter. Moist, delicious, and guilt-free!',
    servings: '10 slices',
    time: '50 min bake + 15 min cool',
    ingredients: [
      '4 medium very ripe bananas (with many brown spots)',
      '2 large eggs',
      '1/2 cup any nut butter, unsalted (peanut butter works great)',
      '1 teaspoon pure vanilla extract',
      '2 teaspoons baking powder',
      '1/2 teaspoon baking soda',
      '1 teaspoon cinnamon',
      '1/8 teaspoon salt',
      '1/2 cup coconut flour',
      'Butter or oil to grease the parchment or pan'
    ],
    instructions: [
      'Preheat oven to 350°F. Line 9x5 loaf pan with unbleached parchment paper and grease.',
      'In a large bowl, mash bananas with a fork or masher.',
      'Add eggs, nut butter, vanilla extract, baking powder, baking soda, cinnamon, and salt. Stir to combine.',
      'Add coconut flour and stir well to mix.',
      'Pour batter in prepared loaf pan and bake for 50 minutes or until a toothpick inserted in the middle comes out clean.',
      'Remove from oven and let cool for 15 minutes. Then transfer to a cooling rack to cool completely.',
      'Do not skip cooling time as bread will fall apart. Cut into 10 slices and enjoy!'
    ],
    tips: 'Freezes well! Also stores in the fridge for 5-7 days if it makes it that long!'
  },
  {
    id: 'magic-bars',
    title: 'Magic Bars',
    category: 'snacks',
    tags: ['Detox Friendly', 'Red / Root', 'Violet / Spirit'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/uscs3dax_Vegan-Oatmeal-Peanut-Butter-Cookie-Bars-Gluten-Free-Dairy-Free-Healthy-3.jpg',
    description: 'No-bake energy bars packed with nuts, seeds, and nut butter. Customizable, satisfying, and perfect for on-the-go snacking.',
    servings: '15-20 small bars',
    time: 'Refrigerate overnight',
    ingredients: [
      '3 cups natural nut butters (cashew, peanut, almond)',
      '1/2 cup coconut flour',
      '1 cup coconut flakes',
      '1 cup pumpkin seeds',
      '1/2 cup sunflower seeds',
      '1/2 cup mixed nuts (pecans, walnuts, almonds, cashews)',
      '1/2 cup flax meal',
      '1/4 tsp pink salt',
      '1/2 cup organic raw cacao nibs or semi-sweet chocolate chips (optional)'
    ],
    instructions: [
      'Mix all ingredients in a large bowl.',
      'Mixture should start to firm up. Add more dry ingredients if mixture isn\'t firming up.',
      'Place into a pan (9x12 glass baking dish works well).',
      'Refrigerate at least overnight.',
      'Cut into desired size pieces (makes roughly 15-20 small bars).'
    ],
    tips: 'Substitute any ingredients! Add honey or maple syrup for some sweetness. Great for meal prep and kids love them too!'
  },
  {
    id: 'yogurt-and-nuts',
    title: 'Yogurt & Nuts',
    category: 'snacks',
    tags: ['Detox Friendly'],
    image: 'https://customer-assets.emergentagent.com/job_81134321-5da7-4def-a43f-55f0ee7c6a93/artifacts/l29isvu4_IMG_5038.jpeg',
    description: 'A simple, satisfying snack — creamy full-fat yogurt topped with warming spices, crunchy nuts and seeds. Please use full-fat coconut or regular yogurt (no fat-free!).',
    servings: '1 serving',
    time: '5 minutes',
    ingredients: [
      '1/2 cup or more yogurt (coconut or regular full-fat — no fat-free please!)',
      'Cinnamon, to taste',
      'Vanilla, to taste',
      'Pistachios, to taste',
      'Pumpkin seeds, to taste',
      'Other nuts or seeds of choice, to taste',
      'Honey, to taste'
    ],
    instructions: [
      'Spoon the yogurt into a bowl.',
      'Add cinnamon and vanilla to taste and stir gently.',
      'Top with pistachios, pumpkin seeds, and any other nuts or seeds you love.',
      'Drizzle with honey to taste and enjoy.'
    ],
    tips: 'Keep it full-fat for lasting satiety. Adjust the toppings to whatever you have on hand.'
  },


  // ============ SALADS & LIGHT MEALS ============
  {
    id: 'carrot-salad',
    title: 'Carrot Salad',
    category: 'salads',
    tags: ['Detox Friendly', 'Orange / Flow', 'Yellow / Fire', 'Green / Love'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/23eyu1rn_carrotsalad1-839x1024.jpg',
    description: 'A crunchy, refreshing salad with shredded carrots, fresh herbs, and a zesty citrus dressing.',
    servings: '2 servings',
    time: '15 minutes',
    ingredients: [
      '2 cups shredded carrots',
      '1/4 cup fresh parsley, chopped',
      '2 tablespoons fresh mint, chopped',
      '2 tablespoons olive oil',
      '1 tablespoon lemon juice',
      '1/2 teaspoon cumin',
      '1/4 teaspoon paprika',
      'Pink salt and pepper to taste',
      'Optional: 2 tablespoons raisins or dried cranberries',
      'Optional: 2 tablespoons toasted sunflower seeds or almonds'
    ],
    instructions: [
      'Shred the carrots using a box grater or food processor. Place in a large bowl.',
      'Add the chopped parsley and mint to the carrots.',
      'In a small bowl, whisk together olive oil, lemon juice, cumin, paprika, salt, and pepper.',
      'Pour the dressing over the carrot mixture and toss well to combine.',
      'Add raisins and seeds if using.',
      'Let sit for 5-10 minutes to allow flavors to meld.',
      'Serve chilled or at room temperature.'
    ],
    tips: 'This salad keeps well in the fridge for 2-3 days. The flavors actually improve as it marinates!'
  },
  {
    id: 'celery-salad',
    title: 'Celery Salad',
    category: 'salads',
    tags: ['Detox Friendly', 'Green / Love', 'Orange / Flow'],
    image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/6jgh3wo9_WGC-__-Celery-Salad-4.jpg',
    description: 'A crunchy, refreshing salad with fresh celery, herbs, toasted nuts, and a honey-lemon dressing. Light yet satisfying!',
    servings: '4-6 servings',
    time: '20 minutes',
    ingredients: [
      '--- SALAD ---',
      '2 bunches of celery, sliced',
      '2 large shallots, thinly sliced',
      '1 bunch fresh parsley, chopped',
      '2 bunches fresh cilantro, chopped',
      'Handful of toasted sunflower seeds',
      'Handful of toasted pistachios',
      'Handful of toasted sliced almonds (buy raw, toast in oven until just golden)',
      '1/2 cup dried blueberries, currants, or craisins',
      '--- DRESSING ---',
      'Juice of 2 large lemons (can add 1 small lime for more sourness)',
      '1/4 cup + 2 tbsp avocado oil or olive oil',
      '1 1/2 tsp salt',
      '1 tbsp black pepper',
      '1 tbsp garlic powder',
      '1/4 cup honey'
    ],
    instructions: [
      'Toast raw nuts in oven or toaster oven until just golden. Set aside to cool.',
      'Slice celery and shallots. Chop parsley and cilantro. Add to a large bowl.',
      'Add toasted nuts and dried fruit to the bowl.',
      'In a separate bowl, whisk together lemon juice (and lime if using), oil, salt, pepper, garlic powder, and honey.',
      'Pour dressing over salad and mix well to combine.',
      'Enjoy immediately or marinate in the fridge for 1 hour for enhanced flavor.'
    ],
    tips: 'Keeps for a couple of days in the fridge. The flavors develop beautifully as it marinates!'
  },

  // ============ NATURAL HOME ============
  {
    id: 'home-disinfectant',
    title: 'My Home Disinfectant',
    category: 'natural-home',
    tag: '',
    image: 'https://customer-assets.emergentagent.com/job_700388ba-a714-4c23-a033-dff2d75d65ef/artifacts/6hgg7vzt_Screenshot%202026-05-30%20133031.png',
    description: 'A natural, beautifully scented disinfectant spray that raises the energy in your space. Healthier than commercial products, inexpensive to make, and clients always comment on how good it smells.',
    ingredients: [
      'A beautiful spray bottle — preferably glass, metal or ceramic (the key is to have a really pretty one to do it justice!)',
      'Distilled or filtered water',
      'Rubbing alcohol (or vodka as a substitute)',
      'Hydrogen peroxide (optional — great for killing mold, zero scent)',
      '15 drops Thieves essential oil (adjust for bottle size or desired scent)',
      '15 drops Grapefruit essential oil',
      '15 drops Eucalyptus essential oil',
      'Optional: Cinnamon essential oil (great mold deterrent)',
      'Optional: A few drops of carrier oil (fractionated coconut, grapeseed, or apricot seed) for effective incorporation of ingredients'
    ],
    instructions: [
      'Fill your spray bottle roughly 7/8 of the way with a 70/30 mix of distilled or filtered water and alcohol. You can shift these proportions if you want more alcohol.',
      'Alternative ratio: 50/25/25 Water/Alcohol/Hydrogen Peroxide — hydrogen peroxide is excellent for killing mold and has zero scent, while alcohol has higher disinfectant properties.',
      'Add 15 drops each of Thieves, Grapefruit, and Eucalyptus essential oils. Add more if your bottle is large or to reach your desired scent level.',
      'Optionally add a few drops of Cinnamon essential oil as a mold deterrent.',
      'Optionally add a few drops of carrier oil (fractionated coconut, grapeseed, or apricot seed) — this helps incorporate the ingredients and is especially good for surfaces like yoga mats where alcohol alone may dry them out over time.',
      'Shake well before each use. You can use any essential oils you like — this combo complements beautifully together.'
    ],
    tips: 'NB: Cinnamon is toxic to cats — please be mindful of any scents around animals.\n\nEssential oils, especially Thieves, have natural antibacterial properties — but what\'s even more lovely is that essential oils tend to raise the energy levels inside the home.\n\nYears ago I moved into a very dirty, previously unkept apartment. As much as I cleaned, it never felt "clean." Dirt definitely has a vibration to it. Along came COVID and I was uninterested in using commercial disinfectants at work, but we were required to use disinfectants — so I made this one. Then I began using it at home also because I just loved it. It was convenient, inexpensive, definitely healthier than commercial products, and I never ran out because I could whip more up!\n\nWhat I really noticed was the energy in my space began to change. The more I used this product, the more I noticed the shift. I had already believed in the power of essential oils because I had used and burned them for years. But it was very interesting to notice this shift firsthand. I\'ve never looked back! It\'s still my go-to and my always. Clients often comment "wow, that smells really good" — and it brings smiles to faces.'
  },
  {
    id: 'powdered-laundry-detergent',
    title: 'Natural Laundry Detergent (Powder)',
    category: 'natural-home',
    tag: '',
    image: 'https://customer-assets.emergentagent.com/job_34f346c1-11e1-4dd6-9352-e802879059af/artifacts/oewxnfai_DIY-homemade-liquid-laundry-soap-detergent-DSC03540.jpg',
    description: 'A simple, economical powdered laundry detergent that lasts a long time. Amazing for top-loader machines — see the liquid recipe for front loaders.',
    ingredients: [
      '1 bar of soap (like Fels-Naptha or Castile soap)',
      '1 cup of washing soda',
      '1 cup of borax (optional — can be substituted with baking soda)',
      'Optional: 15-20 drops of your favorite essential oils (my go-to is grapefruit, eucalyptus, and maybe orange)'
    ],
    instructions: [
      'Grate the soap bar into small pieces.',
      'Mix the grated soap with washing soda and borax in a bowl.',
      'Store the mixture in an airtight container.',
      'Use 1-2 tablespoons per load of laundry.'
    ],
    tips: 'I used this for years until I got a front loader and switched to the liquid version (see Liquid Laundry Detergent recipe). This is amazing — it lasts a long time and is very economical.'
  },
  {
    id: 'liquid-laundry-detergent',
    title: 'Natural Laundry Detergent (Liquid)',
    category: 'natural-home',
    tag: '',
    image: 'https://customer-assets.emergentagent.com/job_34f346c1-11e1-4dd6-9352-e802879059af/artifacts/2u7klbfc_simple-natural-homemade-liquid-laundry-detergent-recipe-8-1024x1536.jpg',
    description: 'A simple, non-toxic liquid laundry detergent made with just a few ingredients. Makes 1 gallon — quick, easy, customizable, and perfect for front-loader machines.',
    ingredients: [
      '1 cup borax — freshens, deodorizes, and lifts dirt and stains',
      '1 cup washing soda — freshens and deodorizes',
      '1/2 cup baking soda — boosts cleaning power and softens',
      '1 cup liquid castile soap or Sal Suds — the main cleaning agent, lifts dirt and cleans',
      '50 drops essential oil — optional for scent',
      '15 cups distilled water — found in any grocery store, best as it doesn\'t contain contaminants found in tap or filtered water',
      'Equipment: Large saucepan or Dutch oven (enough to hold 1 gallon)',
      'Storage: 2 half gallon-size glass mason jars, 1 gallon-size jar, or reuse an old detergent bottle'
    ],
    instructions: [
      'Boil 6 Cups of Water: In a large saucepan or Dutch oven, bring 6 cups of water to a slight boil. Once the water begins to boil, turn off the burner.',
      'Add Borax, Washing Soda, More Water & Castile Soap: Add the borax, washing soda, and baking soda. Stir to dissolve. Then add 9 cups of room-temperature water and 1 cup of liquid castile soap. Give the ingredients a stir to combine.',
      'Cool for 5-10 Minutes: Allow the soap to cool for a few minutes before pouring into one large gallon-size jar or smaller containers. Make sure your jar(s) are heat-safe. If not, wait until the soap is cool, then spoon the soap into the jar(s).',
      'Add Essential Oil for Scent: Add an essential oil of choice (if using) to the soap (now in the jar) and stir to combine with the detergent.'
    ],
    tips: 'Benefits of Homemade Laundry Detergent:\n\nSimple Ingredients — The key ingredients are castile soap, borax, and washing soda. They brighten, remove dirt, and fight off stains.\n\nSave Money — It costs about $20 to purchase the ingredients, which make multiple batches and clean many loads of laundry. Castile soap alone has over 24 different uses.\n\nNon-Toxic — Many commercial detergents are made with fragrances and harsh chemicals that can irritate sensitive skin. The ingredients used here are safe and well-researched.\n\nQuick & Easy — You only need 10-15 minutes of hands-on preparation time.\n\nCustomizable — Give it any scent you wish, including NO scent. I personally love my go-to of grapefruit and eucalyptus and maybe some orange — but you can play around!'
  },
  {
    id: 'thyme-pine-floor-cleaner',
    title: 'Thyme & Pine Disinfectant Floor Cleaner',
    category: 'natural-home',
    tag: '',
    image: 'https://images.pexels.com/photos/4239146/pexels-photo-4239146.jpeg?w=600',
    description: 'A naturally fragrant, plant-infused floor cleaner that leaves your home smelling like a forest after rain. Antimicrobial thyme, grounding pine, and bright lemon — gentle on your space and your senses.',
    ingredients: [
      '2 cups white vinegar',
      '1/2 cup fresh thyme',
      '1/2 cup fresh pine needles or small branches',
      'Peels from 1 lemon',
      '1 gallon warm water'
    ],
    instructions: [
      'Place thyme, pine needles, and lemon peels in a glass jar.',
      'Cover with the white vinegar, seal, and let infuse for 2–3 weeks (shake occasionally).',
      'Strain the infused vinegar through a fine mesh or cheesecloth.',
      'Add 1 cup of the infused vinegar to 1 gallon of warm water.',
      'Use to mop floors — leaves them clean with a fresh, grounding scent.'
    ],
    tips: 'The longer you let the herbs infuse, the more potent the scent. Keep the strained infused vinegar in a sealed glass bottle — it lasts months. Avoid on natural stone (marble, granite) — vinegar can etch sealed stone over time.'
  },
  {
    id: 'lavender-sage-orange-glass-cleaner',
    title: 'Lavender, Sage & Orange Glass Cleaner',
    category: 'natural-home',
    tag: '',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600',
    description: 'A streak-free glass cleaner with a calming herbal-citrus aroma. Lavender and sage soothe; orange brightens — perfect for windows, mirrors, and glass surfaces.',
    ingredients: [
      '1 cup white vinegar',
      '1/2 cup fresh lavender',
      '1/2 cup fresh sage',
      'Peels from 2 oranges'
    ],
    instructions: [
      'Combine lavender, sage, and orange peels in a glass jar.',
      'Pour the vinegar over the mixture and seal the jar.',
      'Infuse for 2–4 weeks, shaking the jar occasionally.',
      'Strain the liquid and transfer into a spray bottle.',
      'Spray onto windows and mirrors and wipe — leaves a streak-free finish with a calming herbal-citrus scent.'
    ],
    tips: 'For extra-streak-free results, wipe with a microfiber cloth or crumpled newspaper. Avoid on tinted windows or any surface coated with film.'
  },
  {
    id: 'rose-lavender-orange-surface-spray',
    title: 'Rose, Lavender & Orange Surface Spray',
    category: 'natural-home',
    tag: '',
    image: 'https://images.pexels.com/photos/4239013/pexels-photo-4239013.jpeg?w=600',
    description: 'A floral-citrus all-purpose surface spray that turns wiping down the counter into a sensory ritual. Rose for heart-opening, lavender for calm, orange for joy.',
    ingredients: [
      '1 cup white vinegar',
      '1/2 cup fresh rose petals',
      '1/2 cup fresh lavender flowers',
      'Peel from 1 orange or grapefruit'
    ],
    instructions: [
      'Add the rose petals, lavender flowers, and orange/grapefruit peel to a glass jar.',
      'Cover with vinegar and seal.',
      'Let infuse for 2–4 weeks, shaking occasionally.',
      'Strain and transfer to a spray bottle.',
      'Spray onto tables, countertops, and other surfaces — wipe down for a beautifully scented finish.'
    ],
    tips: 'Use organic, pesticide-free rose petals (your own garden is ideal). For an extra-luxurious version, add a few drops of rose absolute or essential oil after straining.'
  },
  {
    id: 'chamomile-rose-lavender-linen-spray',
    title: 'Chamomile, Rose & Lavender Linen Spray',
    category: 'natural-home',
    tag: '',
    image: 'https://customer-assets.emergentagent.com/job_700388ba-a714-4c23-a033-dff2d75d65ef/artifacts/6byreqts_linen-spray-herbs-with-label-5-755x1024.jpg',
    description: 'A dreamy bedside spritz for pillows, sheets, and soft furnishings. Calendula, rose, and lavender bring a gentle floral aroma that supports rest and resets the room.',
    ingredients: [
      '1/2 cup distilled water',
      '1/2 cup white vinegar',
      '1/4 cup dried calendula (or chamomile) flowers',
      '1/4 cup fresh rose petals',
      '1/4 cup fresh lavender flowers'
    ],
    instructions: [
      'Place calendula (or chamomile), rose petals, and lavender flowers in a glass jar.',
      'Cover with the vinegar and seal.',
      'Infuse for 2–4 weeks, shaking occasionally.',
      'Strain the infused vinegar and combine with the distilled water in a spray bottle.',
      'Spritz lightly over linens, pillows, and fabric surfaces to refresh with a calming floral aroma.'
    ],
    tips: 'Always spray-test on a small hidden patch of fabric first. The vinegar scent fades quickly — what remains is the gentle floral note. Beautiful for bed-turn-down rituals before sleep.'
  },
  {
    id: 'natural-bug-spray',
    title: 'Natural Bug Spray',
    category: 'natural-home',
    tag: '',
    image: 'https://images.pexels.com/photos/4998548/pexels-photo-4998548.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'A simple, great-smelling natural bug spray with citronella and lavender. Easy to mix up and keep on hand for time outdoors.',
    ingredients: [
      '1/4 cup alcohol (rubbing alcohol, vodka, whatever you have)',
      '3/4 cup distilled or filtered water (distilled gives a longer shelf life, or use boiled water)',
      '15 drops citronella essential oil',
      'Lavender essential oil, to scent liking',
      '1/2 tsp vanilla extract, or to smell liking'
    ],
    instructions: [
      'Mix all ingredients together.',
      'Pour into a spray bottle.',
      'Use generously.'
    ],
    tips: 'Distilled water gives the longest shelf life. Shake before each use, and reapply as needed when spending time outdoors.'
  }
];

export const recipeCategories = [
  { id: 'all', name: 'All Recipes', icon: '🍽️', image: 'https://images.unsplash.com/photo-1466637574441-749b8f19452f?w=600', description: 'Every recipe, filterable by type or body system', count: 0 },
  { id: 'teas', name: 'Teas & Elixirs', icon: '🍵', image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=600', description: 'Healing detox teas, tonics and warming elixirs' },
  { id: 'smoothies', name: 'Smoothies', icon: '🥤', image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=600', description: 'Nutrient-packed blends to start your day' },
  { id: 'breakfast', name: 'Breakfasts', icon: '🍳', image: 'https://images.unsplash.com/photo-1497888329096-51c27beff665?w=600', description: 'Nourishing ways to start your morning' },
  { id: 'soups', name: 'Soups, Stews & Broths', icon: '🥣', image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=600', description: 'Nourishing broths, stews and creamy soups' },
  { id: 'mains', name: 'Main Dishes', icon: '🍗', image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=600', description: 'Satisfying meals for lunch and dinner' },
  { id: 'salads', name: 'Salads & Light Meals', icon: '🥗', image: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=600', description: 'Fresh salads and lighter fare' },
  { id: 'gluten-free', name: 'Gluten Free', icon: '🌾', image: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/0z19jrr0_Gluten-free-food-1139277998-Blog-OpenGraph.jpg', description: 'Delicious gluten-free breads, baked goods & alternatives' },
  { id: 'snacks', name: 'Snacks & Treats', icon: '🍪', image: 'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=600', description: 'Healthy bites and guilt-free treats' },
  { id: 'essentials', name: 'Essentials', icon: '🫒', image: 'https://images.unsplash.com/photo-1534939561126-855b8675edd7?w=600', description: 'Pantry staples and building blocks' },
  { id: 'dressings', name: 'Dressings', icon: '🫒', image: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=600', description: 'Homemade sauces and vinaigrettes' },
  { id: 'natural-home', name: 'Natural Home', icon: '🏡', image: 'https://images.unsplash.com/photo-1549049950-48d5887197a0?w=600', description: 'Simple, natural solutions for a healthier home' },
  { id: 'natural-beauty', name: 'Natural Beauty & Skin Care', icon: '✨', image: 'https://customer-assets.emergentagent.com/job_34f346c1-11e1-4dd6-9352-e802879059af/artifacts/lfbtgen7_Kind-Store-Banner-B%20%281%29.webp', description: 'Clean, natural recipes for glowing skin and self-care' },
];

export const recipeTags = [
  { id: 'all', name: 'All', color: 'bg-stone-200 text-stone-700' },
  { id: 'Detox Friendly', name: 'Detox Friendly', color: 'bg-emerald-100 text-emerald-700' },
  { id: 'CRAP Cleanse Friendly', name: 'CRAP Cleanse Friendly', color: 'bg-amber-100 text-amber-700' },
  { id: 'Gluten Free', name: 'Gluten Free', color: 'bg-stone-100 text-stone-700' },
  { id: 'Red / Root', name: 'Red / Root', color: 'bg-red-100 text-red-700' },
  { id: 'Orange / Flow', name: 'Orange / Flow', color: 'bg-orange-100 text-orange-700' },
  { id: 'Yellow / Fire', name: 'Yellow / Fire', color: 'bg-yellow-100 text-yellow-700' },
  { id: 'Green / Love', name: 'Green / Love', color: 'bg-green-100 text-green-700' },
  { id: 'Blue / Truth', name: 'Blue / Truth', color: 'bg-sky-100 text-sky-700' },
  { id: 'Indigo / Insight', name: 'Indigo / Insight', color: 'bg-indigo-100 text-indigo-700' },
  { id: 'Violet / Spirit', name: 'Violet / Spirit', color: 'bg-violet-100 text-violet-700' },
  { id: 'Rainbow / All Systems', name: 'Rainbow', color: 'bg-gradient-to-r from-red-200 via-yellow-200 to-violet-200 text-stone-700' },
];

// ============ SYSTEM ENHANCING MAP ============
// Anatomy + endocrine gland each system supports — sourced from Jill's "Seven Systems" chart.
// Used in the recipe modal to show what a color-tagged recipe enhances in the body.
export const systemEnhancing = {
  'Red / Root': {
    name: 'The Root',
    gland: 'Adrenals',
    anatomy: ['Blood cells', 'Bones', 'DNA', 'Immune system', 'Joints', 'Legs and feet', 'Muscles', 'Rectum', 'Skin', 'Tailbone (coccyx)'],
    pill: 'bg-red-100 text-red-700 border-red-200',
  },
  'Orange / Flow': {
    name: 'The Flow',
    gland: 'Ovaries / Testes',
    anatomy: ['Bladder', 'Hips', 'Kidneys', 'Large intestine', 'Reproductive system', 'Sacrum'],
    pill: 'bg-orange-100 text-orange-700 border-orange-200',
  },
  'Yellow / Fire': {
    name: 'The Fire',
    gland: 'Pancreas',
    anatomy: ['Gallbladder', 'Liver', 'Small intestine', 'Stomach'],
    pill: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  },
  'Green / Love': {
    name: 'The Love',
    gland: 'Thymus & Heart',
    anatomy: ['Armpits', 'Arms', 'Blood vessels', 'Breasts', 'Hands', 'Lungs', 'Lymphatic system', 'Shoulders', 'Wrists'],
    pill: 'bg-green-100 text-green-700 border-green-200',
  },
  'Blue / Truth': {
    name: 'The Truth',
    gland: 'Thyroid',
    anatomy: ['Cheeks', 'Chin', 'Ears', 'Mouth', 'Neck', 'Nose', 'Throat'],
    pill: 'bg-sky-100 text-sky-700 border-sky-200',
  },
  'Indigo / Insight': {
    name: 'The Insight',
    gland: 'Pituitary',
    anatomy: ['Brain', 'Eyebrows', 'Eyes', 'Forehead', 'Neurons', 'Neurotransmitters'],
    pill: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  },
  'Violet / Spirit': {
    name: 'The Spirit',
    gland: 'Pineal',
    anatomy: ['Electromagnetic field', 'Energy meridians', 'Nervous system'],
    pill: 'bg-violet-100 text-violet-700 border-violet-200',
  },
};
